<template>
  <div
    class="gt-main-wrapper"
    style="position: fixed; top: 0; left: 0; width: 100%; height: 100vh; display: flex; flex-direction: row; z-index: 100000; overflow: hidden">
    <!-- CPA Drawing View when teacher accepts student help in Game On -->
    <div
      v-if="cpaDrawUrl"
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 100001; background: #fff; display: flex; flex-direction: column">
      <!-- Multi-Student Whiteboard Switcher Tabs on Top -->
      <div
        class="teacher-wb-tabs-bar"
        style="
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px 16px;
          background: #f8fafc;
          border-bottom: 1px solid #e2e8f0;
          flex-shrink: 0;
          z-index: 10;
        ">
        <div style="display: flex; align-items: center; gap: 6px; margin-right: 8px; color: #475569; font-size: 13px; font-weight: 600">
          <i class="el-icon-folder-opened" style="font-size: 15px; color: #0284c7"></i>
          <span>Student Whiteboards:</span>
        </div>

        <div
          v-for="st in (channelStudents && channelStudents.length ? channelStudents : [{ identity: activeWhiteboardStudentIdentity || 'active', name: 'Current Student', cpaDrawUrl }])"
          :key="st.identity"
          @click="selectWhiteboardTab(st)"
          :style="{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '6px 14px',
            borderRadius: '6px',
            fontSize: '13px',
            fontWeight: activeWhiteboardStudentIdentity === st.identity ? '600' : '500',
            cursor: 'pointer',
            background: activeWhiteboardStudentIdentity === st.identity ? '#ffffff' : '#f1f5f9',
            color: activeWhiteboardStudentIdentity === st.identity ? '#0284c7' : '#64748b',
            boxShadow: activeWhiteboardStudentIdentity === st.identity ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
            border: activeWhiteboardStudentIdentity === st.identity ? '1.5px solid #0284c7' : '1px solid #cbd5e1',
            transition: 'all 0.15s ease',
          }">
          <i :class="activeWhiteboardStudentIdentity === st.identity ? 'el-icon-edit' : 'el-icon-user'"></i>
          <span>{{ st.name || st.identity }}</span>
          <span
            v-if="activeWhiteboardStudentIdentity === st.identity"
            style="font-size: 10px; background: #e0f2fe; color: #0369a1; padding: 2px 6px; border-radius: 10px; font-weight: 700; text-transform: uppercase">
            Active
          </span>
        </div>
      </div>

      <!-- Drawing Canvas iframe -->
      <div style="flex: 1; width: 100%; height: 100%; position: relative">
        <iframe :key="cpaDrawUrlKey" :src="cpaDrawUrl" frameborder="0" style="width: 100%; height: 100%; border: none" tabindex="-1"></iframe>
      </div>
    </div>
    <div class="gt-overlay" :class="{'gt-projector-bg': !isDashboard}" style="flex: 1; height: 100%; position: relative; overflow: hidden">
      <!-- TOP HEADER -->
      <div class="gt-header">
        <div class="gt-header-left">
          <div style="background: #22db98; width: 26px; height: 26px; border-radius: 6px; display: flex; align-items: center; justify-content: center">
            <i class="fa fa-rocket" style="color: #fff; font-size: 12px; margin: 0; padding: 0"></i>
          </div>
          <span>GAME MODE</span>
        </div>
        <div class="gt-header-right" style="margin-left: auto; display: flex; align-items: center; gap: 16px">
          <span v-if="!isDashboard" style="font-size: 9px; letter-spacing: 1px; font-weight: bold; text-transform: uppercase; color: #fff"
            >TEACHER'S VIEW : PROJECTOR</span
          >
          <template v-else>
            <span style="font-size: 9px; letter-spacing: 1px; font-weight: bold; text-transform: uppercase; color: #64748b">TEACHER'S VIEW : DASHBOARD</span>
          </template>
        </div>
      </div>

      <div class="gt-main" :class="{'gt-mobile-dashboard': isDashboard}">
        <!-- LEFT PANEL -->
        <div class="gt-left-panel">
          <!-- MOBILE-ONLY: Projector Tabs -->
          <div v-if="!isDashboard" class="gt-projector-tabs">
            <div class="gt-pt-tab" :class="{active: activeProjectorMobileTab === 'race'}" @click="activeProjectorMobileTab = 'race'">Live Race</div>
            <div class="gt-pt-tab" :class="{active: activeProjectorMobileTab === 'leaderboard'}" @click="activeProjectorMobileTab = 'leaderboard'">
              Leaderboard
            </div>
          </div>

          <!-- MOBILE-ONLY: Dashboard Tabs -->
          <div v-if="isDashboard" class="gt-projector-tabs gt-dashboard-tabs">
            <div class="gt-pt-tab" :class="{active: activeDashboardMobileTab === 'analytics'}" @click="activeDashboardMobileTab = 'analytics'">
              Live Analytics
            </div>
            <div class="gt-pt-tab" :class="{active: activeDashboardMobileTab === 'leaderboard'}" @click="activeDashboardMobileTab = 'leaderboard'">
              Leader Board
            </div>
            <div class="gt-pt-tab" :class="{active: activeDashboardMobileTab === 'logs'}" @click="activeDashboardMobileTab = 'logs'">Activity LOG</div>
          </div>

          <div class="gt-timer-box">
            <div class="gt-timer-label">TIME REMAINING</div>
            <div class="gt-timer-value" v-if="!gameAnalysisMode && !showGameOver">{{ formatTime(timeRemaining) }}</div>
            <div v-else>
              <div class="gt-timer-value" style="color: #ffb7b7">00:00</div>
              <div style="color: #ef4444; font-size: 11px; font-weight: bold; text-align: center; margin-top: 6px">
                <i class="fa fa-times" style="margin-right: 4px"></i> Game Over
              </div>
            </div>
            <button v-if="!gameAnalysisMode && !showGameOver" class="gt-btn-end" @click="endGame(true)">
              <i class="fa fa-times" style="margin-right: 5px"></i> END SESSION
            </button>
          </div>

          <!-- MOBILE-ONLY: Race Track between timer and leaderboard -->
          <div v-if="!isDashboard" class="gt-mobile-race" :class="{'gt-hide-on-mobile': activeProjectorMobileTab !== 'race'}">
            <div class="gt-section-title" style="margin-top: 8px">LIVE RACE STATUS</div>
            <div class="gt-mobile-race-labels">
              <div v-for="team in sortedTeams" :key="'ml-' + team.id" class="gt-mobile-race-label">
                <div class="gt-mobile-race-name" :style="{color: team.color}">{{ team.name.replace('TEAM ', '') }}</div>
                <div class="gt-mobile-race-pct" :style="{color: team.color}">{{ Math.round(team.progress || 0) }}%</div>
              </div>
            </div>
            <div class="gt-race-track gt-mobile-race-track">
              <div v-for="team in sortedTeams" :key="'mr-' + team.id" class="gt-rocket-lane">
                <div
                  class="gt-rocket-wrapper"
                  :class="{'rocket-moving': movingTeams.has(team.id), 'rocket-finished': team.progress >= 100}"
                  :style="{bottom: getRocketBottom(team.progress) + '%'}">
                  <div class="gt-rocket-label" :style="{borderColor: team.color, color: team.color}">
                    {{ team.name.replace('TEAM', 'Team') }} • {{ team.score || 0 }}
                    <div v-if="teamScorePopups[team.id]" class="gt-score-popup">+2</div>
                  </div>
                  <div class="gt-rocket-icon" :style="{color: team.color}">
                    <svg class="rocket-svg" viewBox="0 0 680 580" xmlns="http://www.w3.org/2000/svg">
                      <defs>
                        <radialGradient :id="'mg1-' + team.id" cx="50%" cy="88%" r="70%" spreadMethod="pad">
                          <stop offset="0%" stop-color="#FFFFFF" />
                          <stop offset="10%" stop-color="#E0FFFF" />
                          <stop offset="30%" stop-color="#00FFFF" />
                          <stop offset="55%" stop-color="#0088FF" />
                          <stop offset="85%" stop-color="#0033CC" />
                          <stop offset="100%" stop-color="#001A66" stop-opacity="0" />
                        </radialGradient>
                        <filter :id="'m-hyper-glow-' + team.id">
                          <feGaussianBlur stdDeviation="3.5" result="coloredBlur" />
                          <feMerge>
                            <feMergeNode in="coloredBlur" />
                            <feMergeNode in="SourceGraphic" />
                          </feMerge>
                        </filter>
                        <radialGradient :id="'mg2-' + team.id" cx="50%" cy="90%" r="60%">
                          <stop offset="0%" stop-color="#FFFFFF" />
                          <stop offset="15%" stop-color="#CCFFFF" />
                          <stop offset="45%" stop-color="#00DDFF" />
                          <stop offset="80%" stop-color="#0055FF" />
                          <stop offset="100%" stop-color="#0022AA" stop-opacity="0" />
                        </radialGradient>
                        <radialGradient :id="'mg3-' + team.id" cx="50%" cy="92%" r="46%">
                          <stop offset="0%" stop-color="#FFFFFF" />
                          <stop offset="12%" stop-color="#E0FFFF" />
                          <stop offset="55%" stop-color="#00CCFF" />
                          <stop offset="100%" stop-color="#0066FF" stop-opacity="0" />
                        </radialGradient>
                        <radialGradient :id="'mg4-' + team.id" cx="50%" cy="95%" r="40%">
                          <stop offset="0%" stop-color="#FFFFFF" />
                          <stop offset="30%" stop-color="#CCFFFF" />
                          <stop offset="100%" stop-color="#00EEFF" stop-opacity="0" />
                        </radialGradient>
                        <radialGradient :id="'mglow1-' + team.id" cx="50%" cy="72%" r="65%">
                          <stop offset="0%" stop-color="#00FFFF" stop-opacity=".92" />
                          <stop offset="50%" stop-color="#0088FF" stop-opacity=".52" />
                          <stop offset="100%" stop-color="#0033CC" stop-opacity="0" />
                        </radialGradient>
                        <radialGradient :id="'mglow2-' + team.id" cx="50%" cy="68%" r="78%">
                          <stop offset="0%" stop-color="#00CCFF" stop-opacity=".42" />
                          <stop offset="100%" stop-color="#0022AA" stop-opacity="0" />
                        </radialGradient>
                      </defs>
                      <g class="rg">
                        <image :href="rocketImgSrc" x="60" y="-20" width="560" height="370" />
                        <ellipse cx="340" cy="328" rx="70" ry="24" :fill="'url(#mglow2-' + team.id + ')'" class="gl" />
                        <ellipse cx="340" cy="315" rx="50" ry="17" :fill="'url(#mglow1-' + team.id + ')'" class="gl" />
                        <g>
                          <g class="l1">
                            <path
                              d="M298 298 Q314 368 340 500 Q366 368 382 298 Q364 322 340 327 Q316 322 298 298Z"
                              :fill="'url(#mg1-' + team.id + ')'"
                              :filter="'url(#m-hyper-glow-' + team.id + ')'" />
                          </g>
                          <g class="l2">
                            <path
                              d="M306 298 Q320 358 340 480 Q360 358 374 298 Q360 318 340 323 Q320 318 306 298Z"
                              :fill="'url(#mg2-' + team.id + ')'"
                              :filter="'url(#m-hyper-glow-' + team.id + ')'" />
                          </g>
                          <g class="l3">
                            <path
                              d="M314 299 Q326 345 340 450 Q354 345 366 299 Q355 316 340 320 Q325 316 314 299Z"
                              :fill="'url(#mg3-' + team.id + ')'"
                              :filter="'url(#m-hyper-glow-' + team.id + ')'" />
                          </g>
                          <g class="l4">
                            <path
                              d="M321 300 Q332 335 340 420 Q348 335 359 300 Q351 313 340 316 Q329 313 321 300Z"
                              :fill="'url(#mg4-' + team.id + ')'"
                              :filter="'url(#m-hyper-glow-' + team.id + ')'" />
                          </g>
                          <path d="M331 300 Q336 324 340 390 Q344 324 349 300 Q345 309 340 311 Q335 309 331 300Z" fill="white" opacity=".96" />
                          <g class="l2">
                            <path d="M306 298 Q320 358 340 412 Q360 358 374 298 Q360 318 340 323 Q320 318 306 298Z" :fill="'url(#mg2-' + team.id + ')'" />
                          </g>
                          <g class="l3">
                            <path d="M314 299 Q326 345 340 388 Q354 345 366 299 Q355 316 340 320 Q325 316 314 299Z" :fill="'url(#mg3-' + team.id + ')'" />
                          </g>
                          <g class="l4">
                            <path d="M321 300 Q332 335 340 364 Q348 335 359 300 Q351 313 340 316 Q329 313 321 300Z" :fill="'url(#mg4-' + team.id + ')'" />
                          </g>
                          <path d="M331 300 Q336 324 340 346 Q344 324 349 300 Q345 309 340 311 Q335 309 331 300Z" fill="white" opacity=".96" />
                          <ellipse cx="340" cy="302" rx="7" ry="4" fill="#00FFFF" class="s1" />
                          <ellipse cx="340" cy="302" rx="5" ry="3" fill="#0088FF" class="s2" />
                          <circle cx="340" cy="302" r="4" fill="#CCFFFF" class="s3" />
                          <circle cx="340" cy="302" r="3.5" fill="#0055FF" class="s4" />
                          <ellipse cx="340" cy="302" rx="5" ry="3" fill="#00DDFF" class="s5" />
                          <circle cx="340" cy="302" r="3" fill="#0099FF" class="s6" />
                          <circle cx="340" cy="302" r="5" fill="#00EEFF" class="s7" />
                          <ellipse cx="340" cy="302" rx="6" ry="3.5" fill="#0066FF" class="s8" />
                          <circle cx="340" cy="302" r="3" fill="#00BBFF" class="s9" />
                          <ellipse cx="340" cy="302" rx="4" ry="2.5" fill="#00FFEE" class="s10" />
                          <ellipse cx="340" cy="302" rx="9" ry="5" fill="#0099FF" opacity=".44" class="w1" />
                          <ellipse cx="340" cy="302" rx="7" ry="4" fill="#0077FF" opacity=".36" class="w2" />
                          <ellipse cx="340" cy="302" rx="6" ry="3.5" fill="#00DDFF" opacity=".4" class="w3" />
                          <ellipse cx="340" cy="302" rx="8" ry="4.5" fill="#0055FF" opacity=".28" class="w4" />
                        </g>
                      </g>
                    </svg>
                    <div class="gt-rocket-tail" :style="{background: `linear-gradient(to bottom, ${team.color}, transparent)`}"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="gt-section-title"
            :class="{
              'gt-hide-on-mobile': (!isDashboard && activeProjectorMobileTab !== 'leaderboard') || (isDashboard && activeDashboardMobileTab !== 'leaderboard'),
            }">
            LIVE LEADERBOARD
          </div>
          <div
            class="gt-leaderboard"
            :class="{
              'gt-hide-on-mobile': (!isDashboard && activeProjectorMobileTab !== 'leaderboard') || (isDashboard && activeDashboardMobileTab !== 'leaderboard'),
            }">
            <div v-for="(team, index) in sortedTeams" :key="team.id" class="gt-lb-card" :style="{borderColor: team.color}">
              <div class="gt-lb-rank" :style="{color: team.color}">{{ String(index + 1).padStart(2, '0') }}</div>
              <div class="gt-lb-info">
                <div class="gt-lb-name" :style="{color: team.color}">{{ team.name }}</div>
                <div class="gt-lb-avatars">
                  <div
                    v-for="member in team.members.slice(0, 3)"
                    :key="member.id"
                    class="gt-avatar"
                    :style="{backgroundColor: getContrastColor(member.colorIndex)}">
                    <img v-if="member.avatar" :src="member.avatar" style="width: 100%; height: 100%; border-radius: 50%; object-fit: cover" />
                    <span v-else>{{ getInitials(member.name) }}</span>
                  </div>
                  <div v-if="team.members.length > 3" class="gt-avatar gt-more" style="background-color: #0d2729; color: #00ffff">
                    +{{ team.members.length - 3 }}
                  </div>
                </div>
              </div>
              <div class="gt-lb-score">
                <div class="gt-lb-points" :style="{color: team.color}">{{ team.score || 0 }}</div>
                <div class="gt-lb-points-label">POINTS</div>
              </div>
            </div>
          </div>
        </div>

        <!-- CENTER PANEL: SLIDE VIEWER (dashboard) or ROCKET RACE -->
        <div class="gt-center-panel" :class="{'gt-center-slides': isDashboard, 'gt-hide-on-mobile': isDashboard && activeDashboardMobileTab !== 'analytics'}">
          <!-- DASHBOARD: SLIDE GRID VIEWER -->
          <template v-if="isDashboard">
            <div style="flex: 1; overflow-y: auto; width: 100%; box-sizing: border-box" :style="{paddingTop: isDashboard ? '4px' : '20px'}">
              <template v-if="gameAnalysisMode">
                <div
                  class="gt-hide-on-mobile"
                  style="margin-bottom: 24px; padding: 0px 14px; display: flex; justify-content: space-between; align-items: center">
                  <div>
                    <div style="font-size: 25px; font-weight: 700; color: #1e293b; letter-spacing: 0.5px; display: flex; align-items: baseline; gap: 8px">
                      Overall Analysis
                    </div>
                    <div style="color: #64748b; font-size: 12px; font-weight: 500; margin-top: 12px">
                      Question Performance Overview & Student Engagement Metrics
                    </div>
                  </div>
                  <button
                    @click="leaveGameMode"
                    style="
                      background: white;
                      border: 1px solid #cbd5e1;
                      color: #1e293b;
                      padding: 8px 16px;
                      border-radius: 6px;
                      font-weight: 600;
                      font-size: 12px;
                      cursor: pointer;
                      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
                      transition: all 0.2s;
                    "
                    onmouseover="this.style.background='#f1f5f9'"
                    onmouseout="this.style.background='white'">
                    Leave Game Mode
                  </button>
                </div>
                <div style="background: #eef2ff; border: 1px solid #c7d2fe; border-radius: 8px; padding: 16px 20px; margin: 0 14px 24px">
                  <div style="color: #4f46e5; font-weight: 700; font-size: 12px; margin-bottom: 4px; display: flex; align-items: center; gap: 6px">
                    <i class="fa fa-info-circle"></i> Please Note:
                  </div>
                  <div style="color: #4338ca; font-size: 11px">
                    You need to record demo video for <strong>at least 2 levels for each question</strong>. Utilize the remainder time of the class to explain
                    and record the demo for the entire class
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="gt-hide-on-mobile" style="margin-bottom: 24px; padding: 0px 14px">
                  <div style="font-size: 25px; font-weight: 700; color: #1e293b; letter-spacing: 0.5px; display: flex; align-items: baseline; gap: 8px">
                    Live Analysis
                  </div>
                  <div style="color: #64748b; font-size: 12px; font-weight: 500; margin-top: 12px">
                    Question Performance Overview & Student Engagement Metrics
                  </div>
                </div>
              </template>
              <div class="gt-dashboard-grid" style="overflow-y: visible; height: auto; padding: 0 14px">
                <div
                  v-for="(slide, idx) in gameConfig.slides"
                  :key="slide.id || idx"
                  class="gt-dashboard-card gt-cpa-card-white"
                  :class="{'gt-mobile-expanded': expandedDashboardCards[idx]}"
                  :style="{zIndex: activeTooltipSlideId === getSlideUniqueId(slide, idx) ? 100 : 1}">
                  <div
                    class="gt-dashboard-card-header gt-cpa-card-header-white"
                    style="position: relative; display: flex; justify-content: space-between; align-items: center">
                    <span class="gt-cpa-card-title" style="font-weight: bold; font-size: 10px">Question {{ idx + 1 }}</span>
                    <div class="gt-cpa-header-stats gt-hide-on-mobile">
                      <span class="gt-stat-attempted">{{ getPercentAttempted(slide) }}% Attempted</span>
                      <span class="gt-stat-stuck">{{ getPercentStuck(slide) }}% Stuck</span>
                      <span class="gt-stat-wrong">{{ Math.max(0, getPercentAttempted(slide) - getPercentCorrect(slide)) }}% Wrong</span>
                    </div>
                    <div
                      class="gt-view-btn gt-show-on-mobile-flex"
                      @click.stop="toggleDashboardCard(idx)"
                      style="display: none; width: 24px; justify-content: center; background: rgba(0, 255, 255, 0.1); padding: 4px; border-radius: 4px">
                      <i class="fa" :class="expandedDashboardCards[idx] ? 'fa-caret-up' : 'fa-caret-down'"></i>
                    </div>
                  </div>

                  <div class="gt-dashboard-card-body" style="flex: 1; padding: 12px; overflow-y: hidden; display: flex; flex-direction: column; gap: 10px">
                    <!-- Image if normal slide -->
                    <div
                      v-if="slide.pic && !isCpaQuestion(slide)"
                      class="gt-slide-image"
                      :style="{
                        backgroundImage: 'url(' + Fn.hashToUrl(slide.pic) + ')',
                        minHeight: '150px',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                      }"></div>

                    <!-- CPA Question Details -->
                    <template v-if="isCpaQuestion(slide)">
                      <div style="position: relative; flex: 1; min-height: 0; display: flex; flex-direction: column">
                        <div class="gt-bloom-table-container gt-cpa-table-container">
                          <div class="gt-bloom-table gt-cpa-table" :style="{minWidth: gameAnalysisMode ? '480px' : '420px'}">
                            <div class="gt-bloom-header gt-cpa-table-header" style="position: relative">
                              <div
                                style="
                                  flex: 2.5;
                                  min-width: 135px;
                                  padding-left: 12px;
                                  padding-right: 4px;
                                  position: sticky;
                                  left: 0;
                                  background: #ffffff;
                                  z-index: 2;
                                ">
                                BLOOM LEVEL
                              </div>
                              <div style="flex: 1.5; min-width: 80px; text-align: center">ATTEMPTED</div>
                              <div style="flex: 1.5; min-width: 80px; text-align: center">STUCK</div>
                              <div style="flex: 1.5; min-width: 80px; text-align: center">WRONG</div>
                              <div v-if="gameAnalysisMode" style="flex: 2; min-width: 120px"></div>
                            </div>
                            <div class="gt-bloom-rows gt-cpa-rows">
                              <div v-for="(stat, sIdx) in getCpaBloomStats(slide)" :key="sIdx" class="gt-bloom-row gt-cpa-row" style="position: relative">
                                <div
                                  class="gt-cpa-col-level"
                                  style="
                                    flex: 2.5;
                                    min-width: 135px;
                                    padding-left: 12px;
                                    padding-right: 4px;
                                    position: sticky;
                                    left: 0;
                                    background: #f8fafc;
                                    z-index: 2;
                                    display: flex;
                                    align-items: center;
                                    gap: 6px;
                                  ">
                                  <div class="gt-cpa-level-badge">{{ stat.levelNum }}</div>
                                  <div class="gt-cpa-level-name" style="width: 68px; flex: none">{{ stat.levelNameFormated }}</div>
                                  <template v-if="!gameAnalysisMode">
                                    <el-tooltip content="Abstract question" placement="top">
                                      <button class="gt-cpa-view-btn" style="margin-left: 0" @click.stop="previewCpa(slide, stat, $event, idx)">
                                        <i class="fa fa-eye"></i>
                                      </button>
                                    </el-tooltip>
                                  </template>
                                </div>
                                <div class="gt-cpa-col-stat" style="flex: 1.5; min-width: 80px; color: #1e293b; font-weight: bold">
                                  {{ stat.attempt }}/{{ attendedStudentCount }}
                                </div>
                                <div class="gt-cpa-col-stat" style="flex: 1.5; min-width: 80px; color: #eab308; font-weight: bold">
                                  {{ stat.stuck }}/{{ attendedStudentCount }}
                                </div>
                                <div class="gt-cpa-col-stat" style="flex: 1.5; min-width: 80px; color: #ef4444; font-weight: bold">
                                  {{ stat.wrong }}/{{ attendedStudentCount }}
                                </div>
                                <div
                                  v-if="gameAnalysisMode"
                                  style="
                                    flex: 2;
                                    min-width: 120px;
                                    textalign: right;
                                    paddingright: 12px;
                                    display: flex;
                                    justifycontent: flex-end;
                                    alignitems: center;
                                    gap: 8px;
                                  ">
                                  <button
                                    class="gt-cpa-view-btn"
                                    :style="{
                                      color: hasPostGameDemo(slide, stat.questionId) ? '#1e293b' : '#64748b',
                                      borderColor: hasPostGameDemo(slide, stat.questionId) ? '#94a3b8' : '#cbd5e1',
                                    }"
                                    @click.stop="openPostGameDemo(slide, stat)">
                                    {{ hasPostGameDemo(slide, stat.questionId) ? 'RE-DO DEMO' : 'SHOW DEMO' }}
                                  </button>
                                  <i v-if="hasPostGameDemo(slide, stat.questionId)" class="fa fa-check-circle" style="color: #10b981; font-size: 14px"></i>
                                  <div v-else style="width: 16px"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Mask to cover horizontal scrollbar under fixed BLOOM column -->
                        <div
                          style="
                            position: absolute;
                            left: 0;
                            bottom: 0;
                            width: 135px;
                            height: 6px;
                            background: #ffffff;
                            z-index: 5;
                            pointer-events: none;
                          "></div>
                      </div>
                    </template>
                  </div>

                  <!-- CPA Tooltip (rendered outside card body directly in card container so overflow-y: hidden doesn't clip it) -->
                  <template v-if="isCpaQuestion(slide)">
                    <div
                      v-if="activeTooltipSlideId === getSlideUniqueId(slide, idx)"
                      class="gs-cpa-tooltip gt-hide-on-mobile"
                      :class="{'gs-cpa-tooltip-left': idx % 2 === 0, 'gs-cpa-tooltip-right': idx % 2 !== 0}"
                      :style="{top: tooltipTop + 'px', transform: 'translateY(-100%)', marginTop: '-8px'}"
                      @click.stop="closePreview">
                      <div
                        v-if="!previewCpaData"
                        class="gs-cpa-tooltip-loading"
                        style="padding: 12px; display: flex; align-items: center; justify-content: center; gap: 8px; color: #64748b; font-size: 11px">
                        <i class="fa fa-spinner fa-spin"></i> Loading question...
                      </div>
                      <template v-else>
                        <div class="gs-cpa-tooltip-question" v-html="previewCpaData.abstractData"></div>
                        <div class="gs-cpa-tooltip-options">
                          <div v-for="(opt, oIdx) in previewCpaData.options" :key="oIdx" class="gs-cpa-tooltip-option">
                            <i v-if="opt.on" class="fa fa-check gs-cpa-tooltip-tick"></i>
                            <span :class="{'gs-cpa-tooltip-indent': !opt.on}">{{ opt.val }}</span>
                          </div>
                        </div>
                      </template>
                    </div>
                  </template>
                  <!-- Shifted View Button for non-CPA -->
                  <div v-if="!isCpaQuestion(slide)" class="gt-dashboard-card-footer gt-cpa-card-footer-white">
                    <span></span>
                    <template v-if="gameAnalysisMode">
                      <button
                        class="gt-cpa-view-btn"
                        :style="{color: hasPostGameDemo(slide) ? '#1e293b' : '#64748b', borderColor: hasPostGameDemo(slide) ? '#94a3b8' : '#cbd5e1'}"
                        @click.stop="openPostGameDemo(slide, null)">
                        {{ hasPostGameDemo(slide) ? 'RE-DO DEMO' : 'SHOW DEMO' }}
                      </button>
                      <i v-if="hasPostGameDemo(slide)" class="fa fa-check-circle" style="color: #10b981; font-size: 14px; margin-left: 8px"></i>
                    </template>
                    <template v-else>
                      <button class="gt-cpa-view-btn" @click.stop="previewImage(slide.pic)"><i class="fa fa-eye"></i> VIEW</button>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <!-- DEFAULT: ROCKET RACE -->
          <template v-else>
            <div class="gt-race-track">
              <div v-for="(team, index) in sortedTeams" :key="team.id" class="gt-rocket-lane">
                <div
                  class="gt-rocket-wrapper"
                  :class="{'rocket-moving': movingTeams.has(team.id), 'rocket-finished': team.progress >= 100}"
                  :style="{bottom: getRocketBottom(team.progress) + '%'}">
                  <div class="gt-rocket-label" :style="{borderColor: team.color, color: team.color}">
                    {{ team.name.replace('TEAM ', 'T') }} • {{ team.score || 0 }}
                    <div v-if="teamScorePopups[team.id]" class="gt-score-popup">+2</div>
                  </div>
                  <div class="gt-rocket-icon" :style="{color: team.color}">
                    <svg class="rocket-svg" viewBox="0 0 680 580" xmlns="http://www.w3.org/2000/svg">
                      <defs>
                        <radialGradient :id="'g1-' + team.id" cx="50%" cy="88%" r="70%" spreadMethod="pad">
                          <stop offset="0%" stop-color="#FFFFFF" />
                          <stop offset="10%" stop-color="#E0FFFF" />
                          <stop offset="30%" stop-color="#00FFFF" />
                          <stop offset="55%" stop-color="#0088FF" />
                          <stop offset="85%" stop-color="#0033CC" />
                          <stop offset="100%" stop-color="#001A66" stop-opacity="0" />
                        </radialGradient>
                        <filter :id="'hyper-glow-' + team.id">
                          <feGaussianBlur stdDeviation="3.5" result="coloredBlur" />
                          <feMerge>
                            <feMergeNode in="coloredBlur" />
                            <feMergeNode in="SourceGraphic" />
                          </feMerge>
                        </filter>
                        <radialGradient :id="'g2-' + team.id" cx="50%" cy="90%" r="60%">
                          <stop offset="0%" stop-color="#FFFFFF" />
                          <stop offset="15%" stop-color="#CCFFFF" />
                          <stop offset="45%" stop-color="#00DDFF" />
                          <stop offset="80%" stop-color="#0055FF" />
                          <stop offset="100%" stop-color="#0022AA" stop-opacity="0" />
                        </radialGradient>
                        <radialGradient :id="'g3-' + team.id" cx="50%" cy="92%" r="46%">
                          <stop offset="0%" stop-color="#FFFFFF" />
                          <stop offset="12%" stop-color="#E0FFFF" />
                          <stop offset="55%" stop-color="#00CCFF" />
                          <stop offset="100%" stop-color="#0066FF" stop-opacity="0" />
                        </radialGradient>
                        <radialGradient :id="'g4-' + team.id" cx="50%" cy="95%" r="40%">
                          <stop offset="0%" stop-color="#FFFFFF" />
                          <stop offset="30%" stop-color="#CCFFFF" />
                          <stop offset="100%" stop-color="#00EEFF" stop-opacity="0" />
                        </radialGradient>
                        <radialGradient :id="'glow1-' + team.id" cx="50%" cy="72%" r="65%">
                          <stop offset="0%" stop-color="#00FFFF" stop-opacity=".92" />
                          <stop offset="50%" stop-color="#0088FF" stop-opacity=".52" />
                          <stop offset="100%" stop-color="#0033CC" stop-opacity="0" />
                        </radialGradient>
                        <radialGradient :id="'glow2-' + team.id" cx="50%" cy="68%" r="78%">
                          <stop offset="0%" stop-color="#00CCFF" stop-opacity=".42" />
                          <stop offset="100%" stop-color="#0022AA" stop-opacity="0" />
                        </radialGradient>
                        <!-- Fire gradients for progress >= 100 -->
                        <radialGradient :id="'g1-fire-' + team.id" cx="50%" cy="88%" r="70%" spreadMethod="pad">
                          <stop offset="0%" stop-color="#FFFFFF" />
                          <stop offset="10%" stop-color="#FFFCF0" />
                          <stop offset="30%" stop-color="#FFE000" />
                          <stop offset="55%" stop-color="#FF7000" />
                          <stop offset="85%" stop-color="#CC0000" />
                          <stop offset="100%" stop-color="#AA0000" stop-opacity="0" />
                        </radialGradient>
                        <radialGradient :id="'g2-fire-' + team.id" cx="50%" cy="90%" r="60%">
                          <stop offset="0%" stop-color="#FFFFFF" />
                          <stop offset="15%" stop-color="#FFF8B0" />
                          <stop offset="45%" stop-color="#FFCC00" />
                          <stop offset="80%" stop-color="#FF5500" />
                          <stop offset="100%" stop-color="#FF2200" stop-opacity="0" />
                        </radialGradient>
                        <radialGradient :id="'g3-fire-' + team.id" cx="50%" cy="92%" r="46%">
                          <stop offset="0%" stop-color="#FFFFFF" />
                          <stop offset="12%" stop-color="#FFFFF0" />
                          <stop offset="55%" stop-color="#FFE800" />
                          <stop offset="100%" stop-color="#FF9900" stop-opacity="0" />
                        </radialGradient>
                        <radialGradient :id="'g4-fire-' + team.id" cx="50%" cy="95%" r="40%">
                          <stop offset="0%" stop-color="#FFFFFF" />
                          <stop offset="30%" stop-color="#FFFDE8" />
                          <stop offset="100%" stop-color="#FFE000" stop-opacity="0" />
                        </radialGradient>
                        <radialGradient :id="'glow1-fire-' + team.id" cx="50%" cy="72%" r="65%">
                          <stop offset="0%" stop-color="#FFAA00" stop-opacity=".92" />
                          <stop offset="50%" stop-color="#FF5500" stop-opacity=".52" />
                          <stop offset="100%" stop-color="#FF2200" stop-opacity="0" />
                        </radialGradient>
                        <radialGradient :id="'glow2-fire-' + team.id" cx="50%" cy="68%" r="78%">
                          <stop offset="0%" stop-color="#FF8800" stop-opacity=".42" />
                          <stop offset="100%" stop-color="#FF2200" stop-opacity="0" />
                        </radialGradient>
                        <linearGradient :id="'bodyMain-' + team.id" x1="0%" y1="0%" x2="100%" y2="0%">
                          <stop offset="0%" stop-color="#8A94A8" />
                          <stop offset="18%" stop-color="#C8D0DC" />
                          <stop offset="38%" stop-color="#EEF2F8" />
                          <stop offset="55%" stop-color="#F8FAFE" />
                          <stop offset="72%" stop-color="#D8DDE8" />
                          <stop offset="88%" stop-color="#A8B0C0" />
                          <stop offset="100%" stop-color="#788090" />
                        </linearGradient>
                        <linearGradient :id="'noseCone-' + team.id" x1="0%" y1="0%" x2="100%" y2="0%">
                          <stop offset="0%" stop-color="#6A7488" />
                          <stop offset="22%" stop-color="#A8B4C4" />
                          <stop offset="45%" stop-color="#D0D8E4" />
                          <stop offset="62%" stop-color="#E4EAF2" />
                          <stop offset="78%" stop-color="#B8C0CC" />
                          <stop offset="100%" stop-color="#687080" />
                        </linearGradient>
                        <linearGradient :id="'wingGrad-' + team.id" x1="0%" y1="0%" x2="100%" y2="0%">
                          <stop offset="0%" stop-color="#556070" />
                          <stop offset="40%" stop-color="#8A94A4" />
                          <stop offset="100%" stop-color="#6A7080" />
                        </linearGradient>
                        <linearGradient :id="'nozzleGrad-' + team.id" x1="0%" y1="0%" x2="100%" y2="0%">
                          <stop offset="0%" stop-color="#404850" />
                          <stop offset="30%" stop-color="#788090" />
                          <stop offset="55%" stop-color="#909AA8" />
                          <stop offset="80%" stop-color="#687078" />
                          <stop offset="100%" stop-color="#404850" />
                        </linearGradient>
                        <linearGradient :id="'nozzleRim-' + team.id" x1="0%" y1="0%" x2="100%" y2="0%">
                          <stop offset="0%" stop-color="#303840" />
                          <stop offset="40%" stop-color="#606870" />
                          <stop offset="100%" stop-color="#303840" />
                        </linearGradient>
                        <radialGradient :id="'windowOuter-' + team.id" cx="38%" cy="32%" r="62%">
                          <stop offset="0%" stop-color="#CCE8FF" />
                          <stop offset="45%" stop-color="#4AACEE" />
                          <stop offset="80%" stop-color="#1A6A9A" />
                          <stop offset="100%" stop-color="#0A3A5A" />
                        </radialGradient>
                        <radialGradient :id="'windowInner-' + team.id" cx="32%" cy="28%" r="55%">
                          <stop offset="0%" stop-color="white" stop-opacity=".9" />
                          <stop offset="100%" stop-color="white" stop-opacity="0" />
                        </radialGradient>
                        <linearGradient :id="'stripe1-' + team.id" x1="0%" y1="0%" x2="100%" y2="0%">
                          <stop offset="0%" stop-color="#1A2A6A" stop-opacity=".0" />
                          <stop offset="30%" stop-color="#1A2A6A" stop-opacity=".75" />
                          <stop offset="70%" stop-color="#1A2A6A" stop-opacity=".75" />
                          <stop offset="100%" stop-color="#1A2A6A" stop-opacity=".0" />
                        </linearGradient>
                        <linearGradient :id="'stripe2-' + team.id" x1="0%" y1="0%" x2="100%" y2="0%">
                          <stop offset="0%" stop-color="#8A0010" stop-opacity=".0" />
                          <stop offset="30%" stop-color="#8A0010" stop-opacity=".8" />
                          <stop offset="70%" stop-color="#8A0010" stop-opacity=".8" />
                          <stop offset="100%" stop-color="#8A0010" stop-opacity=".0" />
                        </linearGradient>
                        <linearGradient :id="'heatShield-' + team.id" x1="0%" y1="0%" x2="100%" y2="0%">
                          <stop offset="0%" stop-color="#4A3020" stop-opacity=".0" />
                          <stop offset="35%" stop-color="#6A4428" stop-opacity=".6" />
                          <stop offset="65%" stop-color="#6A4428" stop-opacity=".6" />
                          <stop offset="100%" stop-color="#4A3020" stop-opacity=".0" />
                        </linearGradient>
                        <linearGradient :id="'panelLine-' + team.id" x1="0%" y1="0%" x2="100%" y2="0%">
                          <stop offset="0%" stop-color="#607080" stop-opacity="0" />
                          <stop offset="30%" stop-color="#607080" stop-opacity=".5" />
                          <stop offset="70%" stop-color="#607080" stop-opacity=".5" />
                          <stop offset="100%" stop-color="#607080" stop-opacity="0" />
                        </linearGradient>
                        <radialGradient :id="'exhaustChamber-' + team.id" cx="50%" cy="20%" r="70%">
                          <stop offset="0%" stop-color="#FF6600" stop-opacity=".9" />
                          <stop offset="60%" stop-color="#CC2200" stop-opacity=".6" />
                          <stop offset="100%" stop-color="#440000" stop-opacity=".8" />
                        </radialGradient>
                        <clipPath :id="'bodyClip-' + team.id">
                          <rect x="304" y="128" width="72" height="175" rx="6" />
                        </clipPath>
                      </defs>

                      <g class="rg">
                        <!-- Rocket body image -->
                        <image :href="rocketImgSrc" x="60" y="-20" width="560" height="370" />
                        <ellipse
                          cx="340"
                          cy="328"
                          rx="70"
                          ry="24"
                          :fill="team.progress >= 100 ? 'url(#glow2-fire-' + team.id + ')' : 'url(#glow2-' + team.id + ')'"
                          class="gl" />
                        <ellipse
                          cx="340"
                          cy="315"
                          rx="50"
                          ry="17"
                          :fill="team.progress >= 100 ? 'url(#glow1-fire-' + team.id + ')' : 'url(#glow1-' + team.id + ')'"
                          class="gl" />
                        <!-- Flame layers: longer + fire-colored when progress >= 100 -->
                        <g :transform="team.progress >= 100 ? 'translate(340,298) scale(1,1.5) translate(-340,-298)' : ''">
                          <g class="l1">
                            <path
                              d="M298 298 Q314 368 340 500 Q366 368 382 298 Q364 322 340 327 Q316 322 298 298Z"
                              :fill="team.progress >= 100 ? 'url(#g1-fire-' + team.id + ')' : 'url(#g1-' + team.id + ')'"
                              :filter="'url(#hyper-glow-' + team.id + ')'" />
                          </g>
                          <g class="l2">
                            <path
                              d="M306 298 Q320 358 340 480 Q360 358 374 298 Q360 318 340 323 Q320 318 306 298Z"
                              :fill="team.progress >= 100 ? 'url(#g2-fire-' + team.id + ')' : 'url(#g2-' + team.id + ')'"
                              :filter="'url(#hyper-glow-' + team.id + ')'" />
                          </g>
                          <g class="l3">
                            <path
                              d="M314 299 Q326 345 340 450 Q354 345 366 299 Q355 316 340 320 Q325 316 314 299Z"
                              :fill="team.progress >= 100 ? 'url(#g3-fire-' + team.id + ')' : 'url(#g3-' + team.id + ')'"
                              :filter="'url(#hyper-glow-' + team.id + ')'" />
                          </g>
                          <g class="l4">
                            <path
                              d="M321 300 Q332 335 340 420 Q348 335 359 300 Q351 313 340 316 Q329 313 321 300Z"
                              :fill="team.progress >= 100 ? 'url(#g4-fire-' + team.id + ')' : 'url(#g4-' + team.id + ')'"
                              :filter="'url(#hyper-glow-' + team.id + ')'" />
                          </g>
                          <path
                            d="M331 300 Q336 324 340 390 Q344 324 349 300 Q345 309 340 311 Q335 309 331 300Z"
                            fill="white"
                            opacity=".96"
                            :filter="'url(#hyper-glow-' + team.id + ')'" />
                          <g class="l2">
                            <path
                              d="M306 298 Q320 358 340 412 Q360 358 374 298 Q360 318 340 323 Q320 318 306 298Z"
                              :fill="team.progress >= 100 ? 'url(#g2-fire-' + team.id + ')' : 'url(#g2-' + team.id + ')'" />
                          </g>
                          <g class="l3">
                            <path
                              d="M314 299 Q326 345 340 388 Q354 345 366 299 Q355 316 340 320 Q325 316 314 299Z"
                              :fill="team.progress >= 100 ? 'url(#g3-fire-' + team.id + ')' : 'url(#g3-' + team.id + ')'" />
                          </g>
                          <g class="l4">
                            <path
                              d="M321 300 Q332 335 340 364 Q348 335 359 300 Q351 313 340 316 Q329 313 321 300Z"
                              :fill="team.progress >= 100 ? 'url(#g4-fire-' + team.id + ')' : 'url(#g4-' + team.id + ')'" />
                          </g>
                          <path d="M331 300 Q336 324 340 346 Q344 324 349 300 Q345 309 340 311 Q335 309 331 300Z" fill="white" opacity=".96" />
                          <ellipse cx="340" cy="302" rx="7" ry="4" :fill="team.progress >= 100 ? '#FFE044' : '#00FFFF'" class="s1" />
                          <ellipse cx="340" cy="302" rx="5" ry="3" :fill="team.progress >= 100 ? '#FF8800' : '#0088FF'" class="s2" />
                          <circle cx="340" cy="302" r="4" :fill="team.progress >= 100 ? '#FFEE44' : '#CCFFFF'" class="s3" />
                          <circle cx="340" cy="302" r="3.5" :fill="team.progress >= 100 ? '#FF6600' : '#0055FF'" class="s4" />
                          <ellipse cx="340" cy="302" rx="5" ry="3" :fill="team.progress >= 100 ? '#FFD844' : '#00DDFF'" class="s5" />
                          <circle cx="340" cy="302" r="3" :fill="team.progress >= 100 ? '#FF9900' : '#0099FF'" class="s6" />
                          <circle cx="340" cy="302" r="5" :fill="team.progress >= 100 ? '#FFCC00' : '#00EEFF'" class="s7" />
                          <ellipse cx="340" cy="302" rx="6" ry="3.5" :fill="team.progress >= 100 ? '#FF5500' : '#0066FF'" class="s8" />
                          <circle cx="340" cy="302" r="3" :fill="team.progress >= 100 ? '#FFAA00' : '#00BBFF'" class="s9" />
                          <ellipse cx="340" cy="302" rx="4" ry="2.5" :fill="team.progress >= 100 ? '#FFE000' : '#00FFEE'" class="s10" />
                          <ellipse cx="340" cy="302" rx="9" ry="5" :fill="team.progress >= 100 ? '#FF9900' : '#0099FF'" opacity=".44" class="w1" />
                          <ellipse cx="340" cy="302" rx="7" ry="4" :fill="team.progress >= 100 ? '#FF7700' : '#0077FF'" opacity=".36" class="w2" />
                          <ellipse cx="340" cy="302" rx="6" ry="3.5" :fill="team.progress >= 100 ? '#FFCC00' : '#00DDFF'" opacity=".4" class="w3" />
                          <ellipse cx="340" cy="302" rx="8" ry="4.5" :fill="team.progress >= 100 ? '#FF6600' : '#0055FF'" opacity=".28" class="w4" />
                        </g>
                      </g>
                    </svg>
                    <div class="gt-rocket-tail" :style="{background: `linear-gradient(to bottom, ${team.color}, transparent)`}"></div>
                  </div>
                  <div v-if="team.activeMember" class="gt-rocket-avatar" :style="{borderColor: team.color}">
                    <img v-if="team.activeMember.avatar" :src="team.activeMember.avatar" />
                    <span v-else>{{ getInitials(team.activeMember.name) }}</span>
                    <div class="gt-avatar-tooltip" :style="{borderColor: team.color}">{{ team.activeMember.tooltip }}</div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>

        <!-- RIGHT PANEL: MISSION LOG (ACTIVITY LOG) -->
        <div
          v-if="isDashboard && !gameAnalysisMode"
          class="gt-right-panel"
          :class="{'gt-hide-on-mobile': activeDashboardMobileTab !== 'logs', 'gt-show-on-mobile-flex': activeDashboardMobileTab === 'logs'}">
          <div class="gt-log-header" style="justify-content: space-between; margin-bottom: 16px">
            <div><i class="fa fa-clipboard" style="margin-right: 8px; color: #64748b; font-size: 12px"></i> MISSION ACTIVITY LOG</div>
          </div>
          <div style="display: flex; gap: 16px; margin-bottom: 16px; align-items: center; justify-content: flex-end">
            <label
              style="
                display: flex;
                align-items: center;
                gap: 6px;
                font-size: 9px;
                font-weight: bold;
                color: #1e293b;
                cursor: pointer;
                text-transform: uppercase;
              ">
              <input type="checkbox" v-model="filterStuck" style="accent-color: #2dd4bf; width: 14px; height: 14px; cursor: pointer" />
              <i class="fa fa-dot-circle-o" style="color: #fbbf24; font-size: 12px"></i> STUCK
            </label>
            <label
              style="
                display: flex;
                align-items: center;
                gap: 6px;
                font-size: 9px;
                font-weight: bold;
                color: #1e293b;
                cursor: pointer;
                text-transform: uppercase;
              ">
              <input type="checkbox" v-model="filterWrongAnswer" style="accent-color: #2dd4bf; width: 14px; height: 14px; cursor: pointer" />
              <i class="fa fa-dot-circle-o" style="color: #ef4444; font-size: 12px"></i> WRONG ANSWER
            </label>
          </div>
          <div class="gt-log-list">
            <div
              v-for="(log, idx) in filteredActivityLogs"
              :key="idx"
              class="gt-log-item"
              :class="{
                'gt-log-clickable': !!log.pageId && !(log.score > 0 || (log.text && log.text.includes('correctly') && !log.text.includes('incorrectly'))) && !log.resolved,
              }"
              @click="
                log.pageId && !(log.score > 0 || (log.text && log.text.includes('correctly') && !log.text.includes('incorrectly'))) && !log.resolved && openStudentSlideView(log)
              ">
              <div class="gt-log-item-header">
                <div style="display: flex; align-items: center; gap: 8px; min-width: 0; flex-shrink: 1">
                  <i
                    class="fa"
                    :class="
                      log.resolved
                        ? 'fa-check-circle'
                        : log.isStuck
                        ? 'fa-dot-circle-o'
                        : log.score > 0 || (log.text && log.text.includes('correctly') && !log.text.includes('incorrectly'))
                        ? 'fa-check-circle'
                        : 'fa-dot-circle-o'
                    "
                    :style="{
                      color: log.resolved
                        ? '#10b981'
                        : log.isStuck
                        ? '#fbbf24'
                        : log.score > 0 || (log.text && log.text.includes('correctly') && !log.text.includes('incorrectly'))
                        ? '#10b981'
                        : '#ef4444',
                      fontSize: '16px',
                      flexShrink: '0',
                    }"></i>
                  <span style="font-weight: 700; color: #1e293b; font-size: 13px; letter-spacing: -0.2px">{{
                    log.score > 0 || (log.text && log.text.includes('correctly') && !log.text.includes('incorrectly')) ? 'Correct Answer' : log.resolved ? 'Resolved' : 'Performance Alert'
                  }}</span>
                </div>
                <div
                  v-if="log.isStuck"
                  style="font-size: 8px; display: flex; align-items: center; gap: 4px; flex-shrink: 0; white-space: nowrap; margin-left: auto">
                  <span style="color: #94a3b8; font-weight: 700; letter-spacing: 0.5px; font-size: 8px">IDLE TIME:</span>
                  <span style="color: #475569; font-weight: 600; font-size: 8px">{{ formatIdleTime(log) }}</span>
                </div>
              </div>

              <div class="gt-log-item-body">
                <span v-html="formatLogText(log)"></span>
              </div>

              <div style="border-top: 1px solid #f1f5f9; margin-top: 8px; margin-bottom: 8px"></div>

              <div class="gt-log-item-footer">
                <div style="color: #94a3b8; font-size: 10px">{{ formatLogTime(log) }}</div>
                <template v-if="!(log.score > 0 || (log.text && log.text.includes('correctly') && !log.text.includes('incorrectly')))">
                  <span
                    v-if="log.resolved"
                    style="color: #10b981; font-weight: bold; font-size: 11px; margin-left: 8px">
                    Resolved
                  </span>
                  <button v-else class="gt-log-action-btn" @click.stop="log.pageId && openStudentSlideView(log)">TAKE ACTION</button>
                </template>
              </div>
            </div>
            <div class="gt-log-processing"><span style="letter-spacing: 2px">&#8226;&#8226;&#8226;</span> PROCESSING MISSION DATA...</div>
          </div>
        </div>
      </div>

      <!-- MOBILE-ONLY: End Game button outside scrollable area -->
      <button class="gt-mobile-end-btn" @click="endGame(true)">END GAME</button>

      <!-- CHECK ANSWER POPUP (Take Action First Step) -->
      <TeacherCheckAnswerPopup
        v-if="showTeacherCheckAnswerPopup"
        :log="selectedActivityLog"
        :slide="selectedStudentSlide"
        @close="closeTeacherCheckAnswerPopup"
        @help-student="handleHelpStudentFromCheckAnswer"
        @mark-correct="handleMarkStudentAnswerCorrect" />

      <!-- INITIAL RED/YELLOW CASE OPTIONS POPUP (Take Action) -->
      <div
        v-if="showInterventionInitialPopup"
        class="gs-preview-overlay"
        style="z-index: 1000005; display: flex; justify-content: center; align-items: center; background: rgba(0, 0, 0, 0.5)"
        @click.stop="closeInterventionInitialPopup">
        <div
          style="
            background: #ffffff;
            padding: 24px 32px 40px;
            border-radius: 16px;
            width: 440px;
            max-width: 90vw;
            color: #1e293b;
            position: relative;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
          "
          @click.stop>
          <i
            class="el-icon-close"
            style="position: absolute; top: 24px; right: 24px; font-size: 14px; cursor: pointer; color: #64748b; font-weight: bold"
            @click="closeInterventionInitialPopup"></i>

          <div style="text-align: left; margin-bottom: 24px">
            <div style="font-size: 16px; font-weight: 700; color: #1e293b; margin-bottom: 8px">Take Action</div>
            <div style="color: #64748b; font-size: 11px">How would you like to help the student?</div>
          </div>

          <div style="display: flex; flex-direction: column; gap: 16px">
            <!-- Review Answer Option -->
            <div
              style="
                display: flex;
                align-items: center;
                border: 1px solid #dbeafe;
                border-radius: 12px;
                padding: 16px;
                cursor: pointer;
                transition: all 0.2s;
                background: #ffffff;
              "
              @click="handleReviewAction"
              onmouseover="this.style.borderColor='#93c5fd'; this.style.boxShadow='0 4px 12px rgba(59, 130, 246, 0.1)'"
              onmouseout="this.style.borderColor='#dbeafe'; this.style.boxShadow='none'">
              <div
                style="
                  background: #e0f2fe;
                  width: 56px;
                  height: 56px;
                  border-radius: 12px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin-right: 16px;
                  flex-shrink: 0;
                ">
                <i class="fa fa-edit" style="font-size: 19px; color: #3b82f6"></i>
              </div>
              <div style="flex: 1">
                <div style="font-size: 14px; font-weight: 700; color: #3b82f6; margin-bottom: 4px">Review Answer</div>
                <div style="font-size: 10px; color: #60a5fa; line-height: 1.4">Check student's draft and<br />identify issues</div>
              </div>
              <i class="fa fa-chevron-right" style="color: #bfdbfe; font-size: 12px"></i>
            </div>

            <!-- Give Demo Option -->
            <div
              style="
                display: flex;
                align-items: center;
                border: 1px solid #ede9fe;
                border-radius: 12px;
                padding: 16px;
                cursor: pointer;
                transition: all 0.2s;
                background: #ffffff;
              "
              @click="handleDemoAction"
              onmouseover="this.style.borderColor='#c4b5fd'; this.style.boxShadow='0 4px 12px rgba(139, 92, 246, 0.1)'"
              onmouseout="this.style.borderColor='#ede9fe'; this.style.boxShadow='none'">
              <div
                style="
                  background: #ede9fe;
                  width: 56px;
                  height: 56px;
                  border-radius: 12px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin-right: 16px;
                  flex-shrink: 0;
                ">
                <i class="fa fa-play-circle" style="font-size: 19px; color: #7c3aed"></i>
              </div>
              <div style="flex: 1">
                <div style="font-size: 14px; font-weight: 700; color: #7c3aed; margin-bottom: 4px">Give Demo</div>
                <div style="font-size: 10px; color: #a78bfa; line-height: 1.4">Provide demonstration and<br />walkthrough</div>
              </div>
              <i class="fa fa-chevron-right" style="color: #ddd6fe; font-size: 12px"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- RED CASE OPTIONS POPUP (Show Demo) -->
      <div
        v-if="showRedCaseOptionsPopup"
        class="gs-preview-overlay"
        style="z-index: 1000005; display: flex; justify-content: center; align-items: center; background: rgba(0, 0, 0, 0.5)"
        @click.stop="closeRedCaseOptionsPopup">
        <div
          style="
            background: #ffffff;
            padding: 24px 32px 40px;
            border-radius: 16px;
            width: 440px;
            max-width: 90vw;
            color: #1e293b;
            position: relative;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
          "
          @click.stop>
          <i
            class="el-icon-close"
            style="position: absolute; top: 24px; right: 24px; font-size: 14px; cursor: pointer; color: #64748b; font-weight: bold"
            @click="closeRedCaseOptionsPopup"></i>

          <div style="text-align: left; margin-bottom: 24px">
            <div style="font-size: 16px; font-weight: 700; color: #1e293b; margin-bottom: 8px">Show Demo</div>
            <div style="color: #64748b; font-size: 11px">How would you like to give demo to the student ?</div>
          </div>

          <div style="display: flex; flex-direction: column; gap: 12px">
            <!-- Live Demo -->
            <div
              style="
                display: flex;
                align-items: center;
                border: 1px solid #10b981;
                border-radius: 12px;
                padding: 16px 20px;
                cursor: pointer;
                transition: all 0.2s;
                background: #ffffff;
              "
              @click="handleDemoOptionClick('live-log')"
              onmouseover="this.style.boxShadow='0 4px 12px rgba(16, 185, 129, 0.15)'"
              onmouseout="this.style.boxShadow='none'">
              <div style="flex: 1">
                <div style="font-size: 13px; font-weight: 700; color: #1e293b; margin-bottom: 6px">Live Demo</div>
                <div style="font-size: 10px; color: #64748b; line-height: 1.4">
                  Invite this Student to the Main Meeting Room<br />to demonstrate the solution live
                </div>
              </div>
              <i class="fa fa-chevron-right" style="color: #10b981; font-size: 12px"></i>
            </div>

            <!-- Group Demo -->
            <div
              style="
                display: flex;
                align-items: center;
                border: 1px solid #10b981;
                border-radius: 12px;
                padding: 16px 20px;
                cursor: pointer;
                transition: all 0.2s;
                background: #ffffff;
              "
              @click="handleDemoOptionClick('group-log')"
              onmouseover="this.style.boxShadow='0 4px 12px rgba(16, 185, 129, 0.15)'"
              onmouseout="this.style.boxShadow='none'">
              <div style="flex: 1">
                <div style="font-size: 13px; font-weight: 700; color: #1e293b; margin-bottom: 6px">Group Demo</div>
                <div style="font-size: 10px; color: #64748b; line-height: 1.4">
                  Invite the whole class to the Main Meeting Room<br />to demonstrate the solution live
                </div>
              </div>
              <i class="fa fa-chevron-right" style="color: #10b981; font-size: 12px"></i>
            </div>

            <!-- Parallel Feedback -->
            <div
              style="
                display: flex;
                align-items: center;
                border: 1px solid #10b981;
                border-radius: 12px;
                padding: 16px 20px;
                cursor: pointer;
                transition: all 0.2s;
                background: #ffffff;
              "
              @click="handleDemoOptionClick('parellel-log')"
              onmouseover="this.style.boxShadow='0 4px 12px rgba(16, 185, 129, 0.15)'"
              onmouseout="this.style.boxShadow='none'">
              <div style="flex: 1">
                <div style="font-size: 13px; font-weight: 700; color: #1e293b; margin-bottom: 6px">Parallel Feedback</div>
                <div style="font-size: 10px; color: #64748b; line-height: 1.4">View Student's Draft & record<br />your Feedback parallelly</div>
              </div>
              <i class="fa fa-chevron-right" style="color: #10b981; font-size: 12px"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- REVIEW RECORDINGS POPUP (Existing Feedback) -->
      <div
        v-if="showReviewRecordingsPopup"
        class="gs-preview-overlay"
        style="z-index: 1000005; display: flex; justify-content: center; align-items: center; background: rgba(0, 0, 0, 0.5)"
        @click.stop="closeReviewRecordingsPopup">
        <div
          style="
            background: #ffffff;
            padding: 24px 32px;
            border-radius: 16px;
            width: 800px;
            max-width: 90vw;
            max-height: 85vh;
            display: flex;
            flex-direction: column;
            color: #1e293b;
            position: relative;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
          "
          @click.stop>
          <i
            class="el-icon-close"
            style="position: absolute; top: 24px; right: 24px; font-size: 14px; cursor: pointer; color: #64748b; font-weight: bold"
            @click="closeReviewRecordingsPopup"></i>

          <!-- Header -->
          <div style="margin-bottom: 24px; text-align: left">
            <div style="color: #1e293b; font-size: 14px; font-weight: 700; margin-bottom: 8px">Existing Feedback found for this this Question</div>
            <div style="color: #64748b; font-size: 11px">You can select any of these demo videos below and send it to the students as feedback</div>
          </div>

          <!-- Video List -->
          <div style="flex: 1; overflow-y: auto; margin-bottom: 24px">
            <div v-if="isFetchingRecordings" style="text-align: center; padding: 40px; color: #64748b">
              <i class="el-icon-loading" style="font-size: 19px; margin-bottom: 10px; display: block"></i>
              Loading recordings...
            </div>
            <div v-else-if="reviewRecordingsList.length === 0" style="text-align: center; padding: 40px; color: #64748b">
              No previous recordings found for this question.
            </div>
            <div v-else style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px">
              <div
                v-for="rec in reviewRecordingsList"
                :key="rec._id"
                @click="selectedRecordingId = rec._id"
                :style="{
                  background: '#ffffff',
                  border: selectedRecordingId === rec._id ? '2px solid #10b981' : '1px solid #e2e8f0',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  cursor: 'pointer',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: '0.2s',
                  boxShadow: selectedRecordingId === rec._id ? '0 4px 12px rgba(16, 185, 129, 0.2)' : '0 2px 4px rgba(0,0,0,0.02)',
                }">
                <!-- Video Placeholder / Player -->
                <div
                  @click.stop="previewVideoUrl = rec.video"
                  style="width: 100%; height: 130px; background: #e2e8f0; position: relative; display: flex; justify-content: center; align-items: center">
                  <video
                    :src="rec.video"
                    @loadedmetadata="handleVideoLoadedMetadata($event, rec.video)"
                    style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; display: block"></video>
                  <i class="fa fa-play" style="font-size: 25px; color: #0f172a; z-index: 1"></i>
                  <div
                    style="
                      position: absolute;
                      bottom: 8px;
                      right: 8px;
                      background: rgba(0, 0, 0, 0.3);
                      color: white;
                      font-size: 9px;
                      padding: 2px 4px;
                      border-radius: 4px;
                    ">
                    {{ videoDurations[rec.video] || '00:00' }}
                  </div>
                </div>

                <!-- Info -->
                <div style="padding: 12px; background: #ffffff">
                  <div style="font-size: 11px; color: #94a3b8; margin-bottom: 4px">
                    Created by : <span style="font-weight: 700; color: #1e293b">{{ rec.fetchedTeacherName || 'John Doe' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div style="display: flex; justify-content: space-between; gap: 16px">
            <button
              style="
                flex: 1;
                padding: 14px;
                background: #ffffff;
                border: 1px solid #10b981;
                color: #10b981;
                font-weight: bold;
                font-size: 10px;
                letter-spacing: 0.5px;
                border-radius: 24px;
                cursor: pointer;
                transition: 0.2s;
                text-transform: uppercase;
              "
              onmouseover="this.style.background='#ecfdf5'"
              onmouseout="this.style.background='#ffffff'"
              @click="createCustomFeedbackWorkflow">
              CREATE CUSTOM FEEDBACK
            </button>
            <button
              style="
                flex: 1;
                padding: 14px;
                border: none;
                font-weight: bold;
                font-size: 10px;
                letter-spacing: 0.5px;
                border-radius: 24px;
                transition: 0.2s;
                text-transform: uppercase;
              "
              :style="{
                background: selectedRecordingId ? '#10b981' : '#34d399',
                color: '#ffffff',
                cursor: selectedRecordingId ? 'pointer' : 'not-allowed',
                opacity: selectedRecordingId ? '1' : '0.6',
              }"
              @click="selectedRecordingId ? applySelectedFeedback() : null">
              APPLY EXISTING FEEDBACK DIRECTLY
            </button>
          </div>
        </div>
      </div>

      <!-- IMAGE PREVIEW OVERLAY -->
      <div v-if="previewPicUrl" class="gs-preview-overlay" @click.stop="closePreview">
        <div class="gs-preview-close" @click.stop="closePreview"><i class="fa fa-times"></i></div>
        <img :src="Fn.hashToUrl(previewPicUrl)" alt="Preview" class="gs-preview-image" @click.stop />
      </div>

      <!-- VIDEO PREVIEW OVERLAY -->
      <div v-if="previewVideoUrl" class="gs-preview-overlay" style="z-index: 1000015" @click.stop="previewVideoUrl = null">
        <div class="gs-preview-close" @click.stop="previewVideoUrl = null"><i class="fa fa-times"></i></div>
        <div
          style="
            background: #000;
            border-radius: 12px;
            overflow: hidden;
            max-width: 90vw;
            max-height: 80vh;
            display: flex;
            justify-content: center;
            align-items: center;
            box-shadow: 0 10px 40px rgba(0, 0, 0, 0.8);
          "
          @click.stop>
          <video :src="previewVideoUrl" controls autoplay style="max-width: 100%; max-height: 80vh; display: block"></video>
        </div>
      </div>

      <!-- Modals moved to be direct children of gt-overlay for better z-index/visibility -->
      <StartDemoPopup
        v-if="showStartDemoPopup"
        :type="startDemoType"
        :curQuestion="selectedStudentSlide"
        :cpaStat="activeCpaStat"
        :isRedoDemo="isRedoDemo"
        :replaceRecording.sync="replaceRecording"
        :studentName="selectedStudentName"
        @start="onStartDemo"
        @close="showStartDemoPopup = false" />
      <SlideAnalyticsModal
        v-if="showSlideAnalytics"
        :slide="selectedAnalysisSlide"
        :responses="responses"
        :analysis="analysis"
        @close="closeSlideAnalytics"
        @close-all="closeAllAnalytics"
        @open-cpa-demo="openCpaDemo" />

      <DemoReplayPage v-if="showCpaDemo" :curQuestion="selectedCpaDemoSlide" :roomId="roomId" @close="closeCpaDemo" />

      <div v-if="showStudentSlideView" class="gt-overlay" style="position: absolute; inset: 0; z-index: 1000000000">
        <DemoSessionPage
          :curQuestion="selectedStudentSlide"
          :studentId="selectedStudentId"
          :studentName="getStudentName(selectedStudentId)"
          :targetUids="groupDemoUids"
          :roomId="roomId"
          :is-red-case="isRedCase || isYellowCase"
          :recording-type="currentRecordingType"
          :isPostGameDemo="isPostGameDemo"
          :isRedoDemo="isRedoDemo"
          :gameOnRecord="gameConfig && gameConfig.gameOnRecord"
          :initialCpaStat="activeCpaStat"
          :cpaStatsList="getCpaBloomStats(selectedStudentSlide)"
          :isReviewAnswerMode="isReviewOnlyMode"
          @close="closeStudentSlideView"
          @sent-recording="markLogAsResolved"
          @demo-sent="handleDemoSent" />
      </div>

      <GameOverModal
        v-if="showGameOver"
        :teams="liveTeams"
        :analysis="analysis"
        :slides="gameConfig.slides"
        :session-questions="session.questions"
        :winner-id="winnerId"
        :status="gameStatus"
        @close="closeGameOver"
        @declare-winner="onDeclareWinner" />
    </div>
  </div>
  <!-- end container -->
</template>

<script>
import {mapActions, mapState, mapGetters} from 'vuex'
import {showLoading, hideLoading} from '@/utils/loading'
import GameOverModal from './GameOverModal.vue'
import SlideAnalyticsModal from './SlideAnalyticsModal.vue'
import DemoReplayPage from './DemoReplayPage.vue'
import DemoSessionPage from './DemoSessionPage.vue'
import StartDemoPopup from './StartDemoPopup.vue'
import TeacherCheckAnswerPopup from './TeacherCheckAnswerPopup.vue'

const rocketSoundSrc = require('./sounds/rocket-sound.mp3')

export default {
  name: 'GameTrackingPage',
  components: {
    GameOverModal,
    SlideAnalyticsModal,
    DemoReplayPage,
    DemoSessionPage,
    StartDemoPopup,
    TeacherCheckAnswerPopup,
  },
  props: {
    gameConfig: {type: Object, required: true},
    teams: {type: Array, required: true},
    isDashboard: {type: Boolean, default: false},
  },
  data() {
    return {
      now: Date.now(),
      nowInterval: null,
      isLocalMeetingActive: false,
      isLocalMeetingStoppedRecently: false,
      activeProjectorMobileTab: 'race',
      activeDashboardMobileTab: 'analytics',
      expandedDashboardCards: {},
      showGameOver: false,
      gameAnalysisMode: false,
      timeRemaining: 0,
      totalTime: 300,
      timerInterval: null,
      movingTeams: new Set(),
      rocketSound: null,
      activityLogs: [],
      liveTeams: [],
      responses: [],
      analysis: null,
      currentSlideIndex: 0,
      showSlideAnalytics: false,
      selectedAnalysisSlide: null,
      showCpaDemo: false,
      selectedCpaDemoSlide: null,
      demoUpdateKey: 0,
      isRedCase: false,
      selectedStudentSlide: null,
      studentSlideViewId: null,
      cpaDrawUrl: '',
      cpaDrawKey: 0,
      channelStudents: [],
      activeWhiteboardStudentIdentity: '',
      showStudentSlideView: false,
      groupDemoUids: [],
      currentRecordingType: null,
      selectedStudentId: null,
      isYellowCase: false,
      showInterventionInitialPopup: false,
      showTeacherCheckAnswerPopup: false,
      selectedActivityLog: null,
      isReviewOnlyMode: false,
      currentRecordingType: 'feedback',
      showRedCaseOptionsPopup: false,
      showStartDemoPopup: false,
      startDemoType: '',
      showReviewRecordingsPopup: false,
      reviewRecordingsList: [],
      isFetchingRecordings: false,
      teamScorePopups: {},
      previewPicUrl: null,
      previewCpaData: null,
      activeTooltipSlideId: null,
      activeTooltipLevelId: null,
      tooltipTop: 0,
      rocketImgSrc: require('../../../assets/Rocket.png'),
      winnerId: null,
      gameStatus: 1,
      selectedRecordingId: null,
      filterStuck: false,
      filterWrongAnswer: false,
      selectedLogId: null,
      isPostGameDemo: false,
      isRedoDemo: false,
      activeCpaStat: null,
      replaceRecording: false,
      isChangingAnalysisMode: false,
      previewVideoUrl: null,
      videoDurations: {},
    }
  },
  computed: {
    cpaDrawUrlKey() {
      return (this.cpaDrawUrl || '') + '_' + (this.cpaDrawKey || 0)
    },
    ...mapState(['session', 'user', 'meeting']),
    isMeetingOngoing() {
      if (this.isLocalMeetingActive) return true
      if (this.isLocalMeetingStoppedRecently) return false

      if (!this.session?.lastMeetingHeartbeat) return false
      return this.now - this.session.lastMeetingHeartbeat < 30000
    },
    roomId() {
      return this.$route && this.$route.params && this.$route.params.id
    },
    ...mapState('teacher', ['gameOnRecentAnswer', 'rooms']),
    ...mapGetters(['isShowStudentName']),
    sortedTeams() {
      // Sort by score descending
      return [...this.liveTeams].sort((a, b) => (b.score || 0) - (a.score || 0))
    },
    selectedStudentName() {
      if (!this.selectedStudentId || !this.liveTeams) return 'Student name'
      const member = this.liveTeams.flatMap((t) => t.members || []).find((m) => m.uid === this.selectedStudentId || m._id === this.selectedStudentId)
      return member ? member.name || member.nickname || 'Student name' : 'Student name'
    },
    currentSlide() {
      const slides = this.gameConfig && this.gameConfig.slides
      if (!slides || !slides.length) return null
      return slides[this.currentSlideIndex] || slides[0]
    },
    attendedStudentCount() {
      const attend = this.rooms && this.rooms.attend
      return (attend && attend.length) || 0
    },
    filteredActivityLogs() {
      return this.activityLogs.filter((log) => {
        if (this.filterStuck && !log.isStuck) return false
        if (this.filterWrongAnswer && !(log.wrongAnswers >= 1 && !log.isStuck)) return false
        if (log.text && log.text.includes('moved to next slide')) return false
        return true
      })
    },
  },
  watch: {
    gameOnRecentAnswer(newAnswer) {
      if (newAnswer) {
        this.processIncomingAnswer(newAnswer)
      }
    },
    gameConfig: {
      handler(val) {
        if (val) {
          if (val.gameStatus) this.gameStatus = val.gameStatus
          if (val.showGameOver !== undefined) this.showGameOver = val.showGameOver
          if (val.gameAnalysisMode !== undefined) this.gameAnalysisMode = val.gameAnalysisMode
          if (val.analysis) this.analysis = val.analysis
          if (val.winnerId) this.winnerId = val.winnerId
          if (val.gameOnRecord && val.gameOnRecord.winnerId) this.winnerId = val.gameOnRecord.winnerId
        }
      },
      deep: true,
    },
    'gameConfig.gameOnRecord.expiresAt': {
      handler(newExpiresAt) {
        if (newExpiresAt && !this.isDashboard) {
          this.startTimer(newExpiresAt)
        }
      },
    },
    'gameConfig.gameOnRecord': {
      handler(val) {
        if (val) {
          if (val.isAnalysisMode !== undefined) {
            this.gameAnalysisMode = val.isAnalysisMode
          }
          if (val.leftGameMode) {
            this.showGameOver = true
          }
          if (val.status === 2 && !this.showGameOver && !this.gameAnalysisMode && !val.leftGameMode) {
            this.updateTeamsFromRecord(val)

            this.endGame()
          }
        }
      },
      deep: true,
      immediate: true,
    },
    timeRemaining(val) {
      // Only trigger end game if timer was actually running
      if (val <= 0 && !this.showGameOver && this.timerInterval) {
        this.endGame(false)
      }
    },
    gameAnalysisMode(newVal) {
      if (newVal) {
        this.closePreview()
      }
    },
    'session.demoReplay': {
      handler(val) {
        if (!val && this.showCpaDemo) {
          this.showCpaDemo = false
          this.selectedCpaDemoSlide = null
        }
        if (!val && this.showStudentSlideView) {
          this.showStudentSlideView = false
          this.selectedStudentSlide = null
        }
      },
    },
    'session.slideSupportData': {
      handler(val) {
        if (!val) {
          if (this.showStudentSlideView) {
            this.showStudentSlideView = false
            this.selectedStudentSlide = null
            this.selectedStudentId = null
          }
        } else if (!this.isDashboard && !this.showStudentSlideView) {
          // Sync projector view to teacher's student slide view
          this.selectedStudentSlide = val
          this.selectedStudentId = this.session.slideSupportUid
          this.showStudentSlideView = true
        }
      },
    },
  },
  mounted() {
    this.rocketSound = new Audio(rocketSoundSrc)
    this.rocketSound.volume = 0.6
    this.initGame()

    this.nowInterval = setInterval(() => {
      this.now = Date.now()
      this.updateLocalState()
    }, 1000)
    window.addEventListener('storage', this.onStorageChange)
    this.updateLocalState()

    // Auto-activate meeting for teacher in Game Mode
    if (this.session && this.session.sid) {
      localStorage.setItem('meeting_active_' + this.session.sid, 'true')
      this.$store.commit('setMeeting', {
        active: true,
        minimized: false,
        name: this.user?.nickname || this.user?.name || 'Teacher',
        sid: this.session.sid,
        sessionId: this.session._id,
        audioMuted: true,
        videoMuted: true,
        isTeacher: true,
      })
      this.$store.dispatch('upSession', {lastMeetingHeartbeat: Date.now()}).catch(() => {})
    }

    if (window.EventBus) {
      window.EventBus.$on('accepted-student-help', this.handleStudentHelpAccepted)
      window.EventBus.$on('left-student-help', this.handleTeacherLeaveHelp)
      window.EventBus.$on('teacher-left-help', this.handleTeacherLeaveHelp)
      window.EventBus.$on('channel-students-updated', this.handleChannelStudentsUpdated)
    }
  },
  beforeDestroy() {
    if (window.EventBus) {
      window.EventBus.$off('accepted-student-help', this.handleStudentHelpAccepted)
      window.EventBus.$off('left-student-help', this.handleTeacherLeaveHelp)
      window.EventBus.$off('teacher-left-help', this.handleTeacherLeaveHelp)
      window.EventBus.$off('channel-students-updated', this.handleChannelStudentsUpdated)
    }
    if (this.nowInterval) {
      clearInterval(this.nowInterval)
    }
    window.removeEventListener('storage', this.onStorageChange)
    if (this.timerInterval) clearInterval(this.timerInterval)
    if (this.unsubscribe) this.unsubscribe()
    if (window.App && this.boundPatchListener) {
      App.service('game-on').removeListener('patched', this.boundPatchListener)
    }
    if (window.App && this.boundScoresListener) {
      App.service('game-on').removeListener('updatedScores', this.boundScoresListener)
    }
    if (window.App && this.boundExpiresAtListener) {
      App.service('game-on').removeListener('updatedExpiresAt', this.boundExpiresAtListener)
    }
    if (window.App && this.boundGameEndedListener) {
      App.service('game-on').removeListener('gameEnded', this.boundGameEndedListener)
    }
    if (window.App && this.boundLatestLogListener) {
      App.service('game-on').removeListener('latestLog', this.boundLatestLogListener)
    }
  },
  destroyed() {
    // Managed by Vue; z-index handles overlaying.
  },
  methods: {
    handleTeacherLeaveHelp(data) {
      if (!data || !data.participant || this.channelStudents.length <= 1) {
        this.cpaDrawUrl = ''
        this.cpaDrawKey = 0
        this.channelStudents = []
        this.activeWhiteboardStudentIdentity = ''
      } else {
        const studentId = data.identity || (data.participant && data.participant.identity)
        if (studentId) {
          this.channelStudents = this.channelStudents.filter((s) => s.identity !== studentId)
          if (this.activeWhiteboardStudentIdentity === studentId && this.channelStudents.length > 0) {
            this.selectWhiteboardTab(this.channelStudents[0])
          }
        }
      }
    },
    handleChannelStudentsUpdated(data) {
      if (!data) return
      if (data.channelStudents) {
        this.channelStudents = data.channelStudents
      }
      if (data.activeStudentIdentity) {
        this.activeWhiteboardStudentIdentity = data.activeStudentIdentity
      }
      if (data.cpaDrawUrl && data.cpaDrawUrl !== '/draw/') {
        if (this.cpaDrawUrl !== data.cpaDrawUrl) {
          this.cpaDrawKey = Date.now()
          this.cpaDrawUrl = data.cpaDrawUrl
        }
      } else if (this.channelStudents.length === 0) {
        this.cpaDrawUrl = ''
        this.cpaDrawKey = 0
      }
    },
    selectWhiteboardTab(st) {
      if (!st || this.activeWhiteboardStudentIdentity === st.identity) return
      this.activeWhiteboardStudentIdentity = st.identity
      if (st.cpaDrawUrl && st.cpaDrawUrl !== '/draw/') {
        this.cpaDrawKey = Date.now()
        this.cpaDrawUrl = st.cpaDrawUrl
      }
      if (window.EventBus) {
        window.EventBus.$emit('teacher-switch-channel-tab', st)
      }
    },
    closeWhiteboard() {
      this.cpaDrawUrl = ''
      this.cpaDrawKey = 0
      this.channelStudents = []
      this.activeWhiteboardStudentIdentity = ''
      if (window.EventBus) {
        window.EventBus.$emit('teacher-close-whiteboard')
        window.EventBus.$emit('teacher-left-help')
      }
    },
    async handleStudentHelpAccepted(data) {
      if (data && data.channelStudents) {
        this.channelStudents = data.channelStudents
      }
      if (data && (data.activeStudentIdentity || data.identity)) {
        this.activeWhiteboardStudentIdentity = data.activeStudentIdentity || data.identity
      }
      this.cpaDrawKey = Date.now()
      const sid = (typeof data === 'object' && data?.sid) || this.session?.sid || this.session?.code
      const slideId = (typeof data === 'object' && (data?.slideId || data?.questionId)) || this.selectedAnalysisSlide?._id || this.selectedAnalysisSlide?.id || this.selectedAnalysisSlide?.page
      const realUid = typeof data === 'object' && data !== null ? (data.uid || data.identity) : data

      const isCpa = this.isCpaQuestion(slideId || this.selectedAnalysisSlide)
      if (!isCpa) {
        this.cpaDrawUrl = ''
        return
      }

      if (typeof data === 'object' && data !== null && data.cpaDrawUrl) {
        this.cpaDrawUrl = data.cpaDrawUrl
        return
      }

      if (realUid && slideId && sid) {
        let studentDrawKey =
          (typeof data === 'object' && data?.studentDrawKey) ||
          this.session?.drawkey ||
          (this.$store && this.$store.state && this.$store.state.session && this.$store.state.session.drawkey) ||
          ''
        if (!studentDrawKey && window.App) {
          try {
            const findRes = await window.App.service('student-draw-key').find({
              query: {
                uid: realUid,
                questionid: slideId,
                sid: sid,
              },
            })
            if (findRes && findRes.data && findRes.data.length > 0) {
              studentDrawKey = findRes.data[0].drawkey || findRes.data[0].drawKey || studentDrawKey
            }
          } catch (e) {
            console.warn('Failed to fetch student draw key', e)
          }
        }

        if (!studentDrawKey && this.session?.drawkey) {
          studentDrawKey = this.session.drawkey
        }

        if (studentDrawKey) {
          const roomId = `${realUid}_${slideId}_${sid}`
          this.cpaDrawUrl = `/draw/#room=${roomId},${studentDrawKey}`
        }
      }
    },
    hasValidAnswer(slide) {
      const fullQuestion = this.getFullQuestion(slide)
      if (!fullQuestion || !fullQuestion.options) return false
      try {
        const opts = typeof fullQuestion.options === 'string' ? JSON.parse(fullQuestion.options) : fullQuestion.options
        if (!Array.isArray(opts)) return false
        return opts.some((opt) => opt.on === true || opt.isCorrect === true)
      } catch (e) {
        return false
      }
    },
    async initGame() {
      const record = this.gameConfig && this.gameConfig.gameOnRecord
      const classMembers =
        (this.$store && this.$store.state && this.$store.state.teacher && this.$store.state.teacher.rooms && this.$store.state.teacher.rooms.members) || []

      // Enrich raw DB members with name/avatar from class roster
      const rawMembers = (record && record.members) || []
      const enrichedMembers = rawMembers.map((m, idx) => {
        const user = classMembers.find((c) => c._id === m.uid) || {}
        let mName = typeof m.name === 'string' ? m.name : Array.isArray(m.name) ? m.name.join(' ') : null
        let cName = user.nickname || user.name

        return {
          uid: m.uid,
          id: m.uid,
          teamId: m.teamId,
          score: m.score || 0,
          name: mName || cName || 'Unknown',
          avatar: m.avatar || user.avatar || user.pic || '',
          colorIndex: idx,
          lockedPages: m.lockedPages || [],
          correctPages: m.correctPages || [],
          lockedQuestionIds: m.lockedQuestionIds || [],
          correctQuestionIds: m.correctQuestionIds || [],
        }
      })

      // Build liveTeams — teams come from the prop (already enriched with color from TeamSelectionModal)
      this.liveTeams = (this.teams || []).map((t) => ({
        ...t,
        score: t.score || 0,
        progress: t.progress || 0,
        members: enrichedMembers.filter((m) => m.teamId === t.id),
      }))

      // Start timer from record's expiresAt if already available
      this.gameStatus = record ? record.status : 1
      this.winnerId = record ? record.winnerId || null : null

      if (record && record.expiresAt && record.status === 1) {
        this.startTimer(record.expiresAt)
      } else if (record && record.status === 2) {
        this.endGame()
      }

      // Listen to real-time patch
      if (window.App && record && (record._id || record.id)) {
        const rId = record._id || record.id
        this.boundPatchListener = (patchRecord) => {
          const pId = patchRecord._id || patchRecord.id
          if (pId === rId) {
            // Trigger the record watcher by updating the object
            if (this.gameConfig && this.gameConfig.gameOnRecord) {
              const updatedRecord = {
                ...this.gameConfig.gameOnRecord,
                ...patchRecord,
              }
              // Prevent old patches from reverting analysis mode during transition
              if (this.isChangingAnalysisMode && patchRecord.isAnalysisMode !== undefined) {
                updatedRecord.isAnalysisMode = this.gameAnalysisMode
              }
              this.$set(this.gameConfig, 'gameOnRecord', updatedRecord)
            }
          }
        }
        App.service('game-on').on('patched', this.boundPatchListener)

        this.boundScoresListener = (data) => {
          if (data && (data._id === record._id || !data._id)) {
            const {updatedTeam, updatedMember, scoreUpdated, updatedSlideId} = data

            const getOrdinal = (n) => {
              const s = ['th', 'st', 'nd', 'rd']
              const v = n % 100
              return `${n}${s[(v - 20) % 10] || s[v] || s[0]}`
            }
            const slideNumber = this.gameConfig.slides.findIndex((slide) => slide.id === updatedSlideId) + 1
            const slideLabel = getOrdinal(slideNumber)

            if (updatedTeam && updatedMember) {
              const liveMatch = this.liveTeams.find((lt) => lt.id === (updatedTeam.id || updatedTeam.teamId))
              if (liveMatch) {
                let mName = Array.isArray(updatedMember.name) ? updatedMember.name.join(' ') : updatedMember.name || 'Student'
                // find matching member for avatar from local state if missing
                let mAvatar = updatedMember.avatar
                if (!mAvatar) {
                  const mm = liveMatch.members.find((m) => m.uid === updatedMember.uid)
                  if (mm) mAvatar = mm.avatar || ''
                }

                const liveMember = liveMatch.members.find((m) => m.uid === updatedMember.uid || m.id === updatedMember.uid)
                if (liveMember) {
                  if (!liveMember.lockedPages) this.$set(liveMember, 'lockedPages', [])
                  if (!liveMember.correctPages) this.$set(liveMember, 'correctPages', [])
                  if (updatedSlideId && !liveMember.lockedPages.includes(updatedSlideId)) {
                    liveMember.lockedPages.push(updatedSlideId)
                  }
                  if (scoreUpdated && updatedSlideId && !liveMember.correctPages.includes(updatedSlideId)) {
                    liveMember.correctPages.push(updatedSlideId)
                  }
                }

                this.$set(liveMatch, 'activeMember', {
                  uid: updatedMember.uid,
                  name: mName,
                  avatar: mAvatar,
                  tooltip: `${mName} ${scoreUpdated ? 'answered' : 'attempted'} ${slideLabel} question`,
                })
                if (liveMatch.avatarTimeout) clearTimeout(liveMatch.avatarTimeout)
                liveMatch.avatarTimeout = setTimeout(() => {
                  this.$set(liveMatch, 'activeMember', null)
                }, 3000)
              }
            }

            if (updatedSlideId) {
              const allSlidesList = this.gameConfig?.slides || this.session?.pages || []
              const slide = allSlidesList.find((s) => s.id === updatedSlideId || s._id === updatedSlideId || s.page === updatedSlideId || s.pageId === updatedSlideId)
              const isCpa = slide ? this.isCpaQuestion(slide) : false
              if (!isCpa) {
                this.playRocketSound()
              }
            }

            // console.log("calling 936", data)
            this.updateTeamsFromRecord(data)
          }
        }
        App.service('game-on').on('updatedScores', this.boundScoresListener)

        this.boundExpiresAtListener = (data) => {
          if (data && data.roomId === record._id) {
            if (data.expiresAt) {
              this.startTimer(data.expiresAt)
            }
          }
        }
        App.service('game-on').on('updatedExpiresAt', this.boundExpiresAtListener)

        this.boundGameEndedListener = (data) => {
          if (data && data.roomId === record._id) {
            if (data.status) {
              this.gameStatus = Number(data.status)
            }
            if (data.analysis) {
              this.analysis = data.analysis
              if (this.gameConfig) {
                this.$set(this.gameConfig, 'analysis', data.analysis)
              }
            }

            // Sync to session for projector view
            if (this.isDashboard && this.session && this.session.gameOnTracking) {
              const updatedTracking = JSON.parse(JSON.stringify(this.session.gameOnTracking))
              if (updatedTracking.gameConfig) {
                updatedTracking.gameConfig.gameStatus = this.gameStatus
                updatedTracking.gameConfig.analysis = this.analysis
                updatedTracking.gameConfig.showGameOver = this.showGameOver
                this.$store.dispatch('upSession', {gameOnTracking: updatedTracking})
              }
            }
          }
        }
        App.service('game-on').on('gameEnded', this.boundGameEndedListener)

        this.boundLatestLogListener = (data) => {
          if (data && data.roomId === record._id) {
            if (data.log) {
              const member = this.liveTeams.flatMap((t) => t.members || []).find((m) => m.uid === data.log.uid)

              const wrongAnswers = (member?.lockedPages?.length || 0) - (member?.correctPages?.length || 0)

              this.activityLogs.unshift({
                id: data.log._id || data.log.id,
                text: data.log.text,
                color: data.log.color,
                iconClass: data.log.iconClass,
                wrongAnswers,
                isStuck: data.log.isStuck,
                pageId: data.log.pageId,
                uid: data.log.uid,
                score: data.log.score || 0,
                idleSince: data.log.idleSince,
                createdAt: data.log.createdAt || new Date(),
                resolved: !!data.log.resolved,
                questionId: data.log.questionId,
                studentAnswer: data.log.studentAnswer,
              })
            }
          }
        }
        App.service('game-on').on('latestLog', this.boundLatestLogListener)

        this.boundLogResolvedListener = (data) => {
          if (data && data.roomId === record._id && data.uid) {
            if (this.activityLogs && this.activityLogs.length) {
              this.activityLogs.forEach((l) => {
                const matchLogId = data.logId && (l.id === data.logId || l._id === data.logId)
                const matchQuestionId = data.questionId && l.questionId === data.questionId
                const matchPageId = !data.logId && !data.questionId && data.pageId && l.pageId === data.pageId
                if (l && l.uid === data.uid && (matchLogId || matchQuestionId || matchPageId)) {
                  l.resolved = true
                  l.color = '#22c55e'
                  l.iconClass = 'fa-check-circle'
                }
              })
            }
          }
        }
        App.service('game-on').on('logResolved', this.boundLogResolvedListener)

        // Fetch current state immediately
        App.service('game-on')
          .get(record._id)
          .then((curr) => {
            this.updateTeamsFromRecord(curr)
            // (Re)start timer using latest expiresAt from server
            if (curr.expiresAt) {
              if (this.timerInterval) clearInterval(this.timerInterval)
              this.startTimer(curr.expiresAt)
            }
          })
          .catch((err) => console.error(err))
      }

      // BROADCAST QUESTIONS TO STUDENTS FOR MISSION LOG
      if (window.App && this.gameConfig && this.gameConfig.slides) {
        App.service('auth').patch('syncTeacher', {
          commit: 'student/setActiveMissionQuestions',
          data: this.gameConfig.slides,
        })
      }

      const activityResponses = await App.service('game-on-log').find({
        query: {
          gameId: record._id,
          $limit: '20',
        },
      })
      activityResponses?.data?.forEach((log) => {
        const member = this.liveTeams.flatMap((t) => t.members || []).find((m) => m.uid === log.uid)

        const wrongAnswers = (member?.lockedPages?.length || 0) - (member?.correctPages?.length || 0)

        this.activityLogs.unshift({
          id: log._id || log.id,
          text: log.text,
          color: log.color,
          iconClass: log.iconClass,
          pageId: log.pageId,
          uid: log.uid,
          isStuck: log.isStuck,
          wrongAnswers,
          score: log.score || 0,
          idleSince: log.idleSince,
          createdAt: log.createdAt,
          resolved: !!log.resolved,
          questionId: log.questionId,
          studentAnswer: log.studentAnswer,
        })
      })
    },
    startTimer(expiresAt) {
      const expiresTime = new Date(expiresAt).getTime()
      this.currentExpiresTime = expiresTime

      const timePerQuestion = (this.gameConfig && (this.gameConfig.timing || this.gameConfig.time)) || 300
      const totalSlides = (this.gameConfig && this.gameConfig.slides && this.gameConfig.slides.length) || 1
      this.totalTime = timePerQuestion * totalSlides

      // clear old timer
      if (this.timerInterval) {
        clearInterval(this.timerInterval)
      }

      const update = () => {
        // Stop timer visually if demo replay is active
        if (this.showCpaDemo || (this.session && this.session.demoReplay)) return

        const now = Date.now()
        const diff = Math.floor((expiresTime - now) / 1000)
        this.timeRemaining = Math.max(0, diff)

        if (diff <= 0) {
          if (!this.isMeetingOngoing) {
            this.handleZoomClick()
          }
          this.endGame(false)
        }
      }

      // run immediately then every second
      update()
      this.timerInterval = setInterval(update, 1000)
    },
    updateTeamsFromRecord(record) {
      if (!record) return

      // Sync top-level status and IDs
      if (record.status !== undefined) {
        this.gameStatus = Number(record.status)
      }
      if (record.winnerId !== undefined) {
        this.winnerId = record.winnerId || null
      }
      if (record.analysis) {
        this.analysis = record.analysis
      }
      if (record.expiresAt && record.status === 1 && record.expiresAt !== this.currentExpiresTime) {
        this.startTimer(record.expiresAt)
      }
      // Demo sync
      if (record.isDemoOn === false && this.showCpaDemo) {
        this.showCpaDemo = false
        this.selectedCpaDemoSlide = null
      }

      if (record.responses && Array.isArray(record.responses)) {
        this.responses = record.responses
      }

      // 1. Sync team-level scores
      if (record.teams && Array.isArray(record.teams)) {
        this.liveTeams = this.liveTeams.map((t) => {
          const dbTeam = record.teams.find((dbt) => dbt.id === t.id)
          if (dbTeam && (dbTeam.score || 0) > (t.score || 0)) {
            this.$set(this.teamScorePopups, t.id, true)
            setTimeout(() => {
              this.$set(this.teamScorePopups, t.id, false)
            }, 2000)
          }
          if (dbTeam && (dbTeam.progress || 0) !== (t.progress || 0)) {
            // Trigger vibration for this team
            const newMoving = new Set(this.movingTeams)
            newMoving.add(t.id)
            this.movingTeams = newMoving

            if (dbTeam.progress >= 100 && (t.progress || 0) < 100) {
              if ((dbTeam.score || 0) > (t.score || 0)) {
                this.playRocketSound()
              }
            }

            setTimeout(() => {
              const updated = new Set(this.movingTeams)
              updated.delete(t.id)
              this.movingTeams = updated
            }, 1200)
          }
          return dbTeam ? {...t, score: dbTeam.score || 0, progress: dbTeam.progress || 0} : t
        })
      }
      // 2. Sync member-level scores and progress (real-time per-student updates)
      const updateMemberObj = (m, dbMember) => {
        return {
          ...m,
          score: dbMember.score || 0,
          lockedPages: dbMember.lockedPages || [],
          correctPages: dbMember.correctPages || [],
          lockedQuestionIds: dbMember.lockedQuestionIds || [],
          correctQuestionIds: dbMember.correctQuestionIds || [],
        }
      }

      if (record.members && Array.isArray(record.members)) {
        this.liveTeams = this.liveTeams.map((t) => ({
          ...t,
          members: (t.members || []).map((m) => {
            const dbMember = record.members.find((dm) => dm.uid === m.uid)
            return dbMember ? updateMemberObj(m, dbMember) : m
          }),
        }))
      } else if (record.updatedMember) {
        // Handle single member update from socket events
        const um = record.updatedMember
        this.liveTeams = this.liveTeams.map((t) => {
          if (t.id === (um.teamId || um.team_id)) {
            return {
              ...t,
              members: (t.members || []).map((m) => {
                return m.uid === um.uid ? updateMemberObj(m, um) : m
              }),
            }
          }
          return t
        })
      }
      // 2. Sync member-level scores (real-time per-student score updates)
      if (record.members && Array.isArray(record.members)) {
        this.liveTeams = this.liveTeams.map((t) => ({
          ...t,
          members: t.members.map((m) => {
            const dbMember = record.members.find((dm) => dm.uid === m.uid)
            return dbMember ? {...m, score: dbMember.score || 0} : m
          }),
        }))
      }
    },
    handleNativeResponse(rs) {
      if (this.timeRemaining <= 0) return

      // 1. Map incoming Feathers response student identity back to their strict GameOn team bounds
      const studentId = rs.user_id || rs.uid || rs.studentId
      let matchingTeam = null
      let memberObj = null

      for (const team of this.liveTeams) {
        const member = team.members.find((m) => m.uid === studentId)
        if (member) {
          matchingTeam = team
          memberObj = member
          break
        }
      }

      // Discard responses from students who aren't currently part of an active racing team
      if (!matchingTeam) return

      // 2. Validate Slide bounds
      const slide = this.gameConfig.slides.find((s) => s.id === rs.page || s.id === rs.page_id || s.id === rs.quizId)

      // 3. Process the validation format & apply point mappings
      const isCorrect = rs.isRight === true || rs.correct === true || rs.score > 0 || (rs.answer && slide && slide.answer && rs.answer === slide.answer) || true // Fallback Boolean flag
      const pointsAwarded = slide && slide.points ? slide.points : 25
      const displayName = memberObj.name || memberObj.nickname || 'Student'

      // if (!this.hasValidAnswer(slide)) {
      //   this.activityLogs.unshift({
      //     text: `<b>${displayName}</b> from ${matchingTeam.name} attempted.`,
      //     color: '#00ffff',
      //     iconClass: 'fa-info-circle',
      //   })
      // } else if (isCorrect) {
      //   // Score update is now handled entirely by game-on backend
      //   this.activityLogs.unshift({
      //     text: `<b>${displayName}</b> from ${matchingTeam.name} answered correctly!`,
      //     color: '#00ff88',
      //     iconClass: 'fa-check-circle',
      //   })
      // } else {
      //   this.activityLogs.unshift({
      //     text: `<b>${displayName}</b> from ${matchingTeam.name} submitted an incorrect answer.`,
      //     color: '#ff3366',
      //     iconClass: 'fa-times-circle',
      //   })
      // }

      // Memory cleanup logic
      // if (this.activityLogs.length > 20) this.activityLogs.pop()

      // Update Local Responses for Real-Time card percentages
      const slideId = rs.page || rs.page_id || rs.quizId
      const existingResponseIndex = this.responses.findIndex(
        (r) =>
          r.uid === studentId &&
          (r.page === slideId || r.page_id === slideId || r.quizId === slideId) &&
          (!rs.questionId || r.questionId === rs.questionId) &&
          !!r.isRetry === !!rs.isRetry
      )
      if (existingResponseIndex !== -1) {
        this.responses.splice(existingResponseIndex, 1, {...this.responses[existingResponseIndex], ...rs})
      } else {
        this.responses.push({...rs, uid: studentId, page: slideId})
      }

      // Update Member progress locally for immediate stats update
      if (matchingTeam && memberObj && slideId) {
        if (!memberObj.lockedPages) this.$set(memberObj, 'lockedPages', [])
        if (!memberObj.lockedPages.includes(slideId)) {
          memberObj.lockedPages.push(slideId)
        }
        if (isCorrect) {
          if (!memberObj.correctPages) this.$set(memberObj, 'correctPages', [])
          if (!memberObj.correctPages.includes(slideId)) {
            memberObj.correctPages.push(slideId)
          }
        }
      }
    },
    goToSlide(idx) {
      const slides = this.gameConfig && this.gameConfig.slides
      if (!slides) return
      this.currentSlideIndex = Math.max(0, Math.min(idx, slides.length - 1))
    },
    prevSlide() {
      this.goToSlide(this.currentSlideIndex - 1)
    },
    nextSlide() {
      this.goToSlide(this.currentSlideIndex + 1)
    },
    formatTime(seconds) {
      const m = Math.floor(seconds / 60)
      const s = seconds % 60
      return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
    },
    getInitials(name) {
      if (!name) return ''
      if (Array.isArray(name)) name = name.join(' ')
      const parts = name.trim().split(' ')
      if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase()
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
    },
    getContrastColor(colorIndex) {
      return '#1a3c40'
    },
    playRocketSound() {
      if (this.rocketSound) {
        this.rocketSound.currentTime = 0
        this.rocketSound.play().catch(() => {})
      }
    },
    getRocketBottom(progress) {
      const minBottom = 8
      if (!progress) return minBottom
      const percentage = minBottom + (progress / 100) * 65
      return Math.min(percentage, 73)
    },
    closeSlideAnalytics() {
      this.showSlideAnalytics = false
    },
    closeAllAnalytics() {
      this.showSlideAnalytics = false
      this.closeGameOver()
    },
    openCpaDemo(slide) {
      this.showSlideAnalytics = false
      this.selectedCpaDemoSlide = {
        ...slide,
        ...this.getFullQuestion(slide),
      }
      this.showCpaDemo = true

      // Sync to session for projector view
      if (this.isDashboard) {
        try {
          this.$store.dispatch('upSession', {demoReplay: this.selectedCpaDemoSlide})
        } catch (e) {
          console.error('Failed to sync demoReplay to session:', e)
        }
      }

      const recordId = this.gameConfig && this.gameConfig.gameOnRecord && this.gameConfig.gameOnRecord._id
      if (recordId && window.App) {
        App.service('game-on').patch(recordId, {isDemoOn: true})
      }
    },
    closeCpaDemo() {
      this.showCpaDemo = false
      this.selectedCpaDemoSlide = null

      const recordId = this.gameConfig && this.gameConfig.gameOnRecord && this.gameConfig.gameOnRecord._id
      if (recordId && window.App) {
        App.service('game-on').patch(recordId, {isDemoOn: false})
      }

      // Clear from session for projector view
      if (this.isDashboard) {
        try {
          this.$store.dispatch('upSession', {demoReplay: null})
        } catch (e) {
          console.error('Failed to clear demoReplay from session:', e)
        }
      }
    },
    onDeclareWinner(team) {
      if (typeof window !== 'undefined' && window.App) {
        this.winnerId = team.id
        App.service('auth')
          .patch('syncTeacher', {
            commit: 'student/setGameWinner',
            data: team.id,
          })
          .catch((err) => console.error('Error syncing game winner', err))

        // Patch backend game-on record to trigger real-time 'patched' event on other screens
        const recordId = this.gameConfig && this.gameConfig.gameOnRecord && this.gameConfig.gameOnRecord._id
        if (recordId) {
          App.service('game-on')
            .patch(recordId, {winnerId: team.id})
            .catch((err) => console.error('Error patching winnerId to DB', err))
        }

        // Sync to session for other teacher/projector views
        if (this.session && this.session.gameOnTracking) {
          const updatedTracking = JSON.parse(JSON.stringify(this.session.gameOnTracking))
          if (updatedTracking.gameConfig && updatedTracking.gameConfig.gameOnRecord) {
            updatedTracking.gameConfig.gameOnRecord.winnerId = team.id
            updatedTracking.gameConfig.winnerId = team.id
            updatedTracking.gameConfig.gameOnRecord.status = 2
            updatedTracking.gameConfig.showGameOver = true
            updatedTracking.teams = this.liveTeams
            this.$store.dispatch('upSession', {gameOnTracking: updatedTracking})
          }
        }
      }
    },
    async endGame(isManual = false) {
      if (this.showGameOver || this.gameAnalysisMode) return

      let allQuestionsHaveCorrectAnswer = true
      if (this.gameConfig && this.gameConfig.slides && this.gameConfig.slides.length > 0) {
        for (const slide of this.gameConfig.slides) {
          const q = this.getFullQuestion(slide)
          if (!q) {
            allQuestionsHaveCorrectAnswer = false
            break
          }
          let hasCorrect = false
          if (this.isCpaQuestion(slide)) {
            if (q.abstract && q.abstract.answer !== undefined && q.abstract.answer !== null && q.abstract.answer !== '') {
              hasCorrect = true
            }
          } else {
            if (q.options && Array.isArray(q.options)) {
              hasCorrect = q.options.some((opt) => opt.on === true || opt.isCorrect === true || opt.correct === true)
            }
            if (!hasCorrect && q.answer !== undefined && q.answer !== null && q.answer !== '') {
              hasCorrect = true
            }
          }
          if (!hasCorrect) {
            allQuestionsHaveCorrectAnswer = false
            break
          }
        }
      } else {
        allQuestionsHaveCorrectAnswer = false
      }

      if (allQuestionsHaveCorrectAnswer && this.liveTeams && this.liveTeams.length > 0) {
        const sortedTeams = [...this.liveTeams].sort((a, b) => (b.score || 0) - (a.score || 0))
        const highestTeam = sortedTeams[0]
        if (highestTeam) {
          this.winnerId = highestTeam.id
          if (typeof window !== 'undefined' && window.App) {
            App.service('auth')
              .patch('syncTeacher', {
                commit: 'student/setGameWinner',
                data: highestTeam.id,
              })
              .catch((err) => console.error('Error syncing game winner', err))

            const recordId = this.gameConfig && this.gameConfig.gameOnRecord && this.gameConfig.gameOnRecord._id
            if (recordId) {
              App.service('game-on')
                .patch(recordId, {winnerId: highestTeam.id})
                .catch((err) => console.error('Error patching auto winnerId to DB', err))
            }
          }
        }
      }

      this.showGameOver = false
      this.gameAnalysisMode = true
      this.closePreview()

      if (this.timerInterval) {
        clearInterval(this.timerInterval)
        this.timerInterval = null
      }

      // Patch game-on record status to 2 (ended) and await backend's generated analysis
      const recordId = this.gameConfig && this.gameConfig.gameOnRecord && this.gameConfig.gameOnRecord._id
      const currentStatus = this.gameConfig && this.gameConfig.gameOnRecord && this.gameConfig.gameOnRecord.status

      let patchedRecord = null

      if (isManual && window.App && recordId && currentStatus !== 2) {
        try {
          patchedRecord = await App.service('game-on').patch(recordId, {status: 2, isAnalysisMode: true})
          if (patchedRecord) {
            this.gameStatus = patchedRecord.status || 2
            if (patchedRecord.analysis) {
              this.analysis = patchedRecord.analysis
            }
            if (this.gameConfig) {
              this.$set(this.gameConfig, 'gameOnRecord', patchedRecord)
              if (this.analysis) {
                this.$set(this.gameConfig, 'analysis', this.analysis)
              }
              this.$set(this.gameConfig, 'responses', this.responses)
            }
          }
        } catch (err) {
          console.error('Failed to set game status=2:', err)
        }
      } else if (!isManual && window.App && recordId && this.gameStatus !== 2) {
        this.gameStatus = 2
        if (this.gameConfig) {
          this.$set(this.gameConfig, 'responses', this.responses)
          if (this.analysis) {
            this.$set(this.gameConfig, 'analysis', this.analysis)
          }
        }
      }

      // Consolidated sync status to session for other teacher/projector views
      if (this.session && this.session.gameOnTracking) {
        const updatedTracking = JSON.parse(JSON.stringify(this.session.gameOnTracking))
        if (updatedTracking.gameConfig) {
          updatedTracking.gameConfig.showGameOver = false
          updatedTracking.gameConfig.gameAnalysisMode = true
          updatedTracking.gameConfig.gameStatus = this.gameStatus
          updatedTracking.gameConfig.responses = this.responses
          if (this.analysis) {
            updatedTracking.gameConfig.analysis = this.analysis
          }
          if (updatedTracking.gameConfig.gameOnRecord) {
            if (patchedRecord) {
              updatedTracking.gameConfig.gameOnRecord = patchedRecord
            }
            updatedTracking.gameConfig.gameOnRecord.status = this.gameStatus
            updatedTracking.gameConfig.gameOnRecord.isAnalysisMode = true
          }
          updatedTracking.teams = this.liveTeams
          this.$store.dispatch('upSession', {gameOnTracking: updatedTracking})
        }
      }

      if (window.App) {
        App.service('auth').patch('syncTeacher', {
          commit: 'student/endGameOn',
          data: true,
        })
        App.service('auth').patch('syncTeacher', {
          commit: 'student/setActiveMissionQuestions',
          data: null,
        })
      }
    },
    closeGameOver() {
      this.showGameOver = false

      if (this.session && this.session.gameOnTracking) {
        const updatedTracking = JSON.parse(JSON.stringify(this.session.gameOnTracking))
        if (updatedTracking.gameConfig) {
          updatedTracking.gameConfig.showGameOver = false
        }
        this.$store.dispatch('upSession', {gameOnTracking: updatedTracking})
      }

      this.$emit('end-game', this.gameConfig)
    },
    leaveGameMode() {
      const allZero = this.liveTeams.every((t) => (t.score || 0) === 0)
      this.gameAnalysisMode = false
      if (!allZero) {
        this.showGameOver = true
      }

      // Update local session
      if (this.session && this.session.gameOnTracking) {
        const updatedTracking = JSON.parse(JSON.stringify(this.session.gameOnTracking))
        if (updatedTracking.gameConfig) {
          updatedTracking.gameConfig.gameAnalysisMode = false
          if (!allZero) {
            updatedTracking.gameConfig.showGameOver = true
          } else {
            updatedTracking.gameConfig.showGameOver = false
          }
          if (updatedTracking.gameConfig.gameOnRecord) {
            updatedTracking.gameConfig.gameOnRecord.isAnalysisMode = false
            updatedTracking.gameConfig.gameOnRecord.leftGameMode = true
          }
        }
        this.$store.dispatch('upSession', {gameOnTracking: updatedTracking})
      }

      const recordId = this.gameConfig && this.gameConfig.gameOnRecord && this.gameConfig.gameOnRecord._id
      if (recordId && window.App) {
        this.isChangingAnalysisMode = true
        App.service('game-on')
          .patch(recordId, {isAnalysisMode: false, leftGameMode: true})
          .then((res) => {
            if (this.gameConfig && this.gameConfig.gameOnRecord) {
              this.$set(this.gameConfig.gameOnRecord, 'isAnalysisMode', false)
              this.$set(this.gameConfig.gameOnRecord, 'leftGameMode', true)
            }
          })
          .catch((err) => console.error(err))
          .finally(() => {
            setTimeout(() => {
              this.isChangingAnalysisMode = false
            }, 2000)
          })

        App.service('auth').patch('syncTeacher', {
          commit: 'student/leaveGameModeOn',
          data: {showWinner: !allZero},
        })
      }

      if (allZero) {
        this.closeGameOver()
      }
    },
    getFullQuestion(slide) {
      if (!slide) return null

      const pageId = slide.page || slide.id || slide.pageId
      const questions = this.session && this.session.questions ? this.session.questions : []
      return questions.find((q) => q.page === pageId || q.id === pageId || q._id === pageId) || slide
    },
    isCpaQuestion(slide) {
      if (!slide) return false
      if (typeof slide === 'object' && slide.hasOwnProperty('isCpa')) {
        return !!slide.isCpa
      }
      const fullQuestion = this.getFullQuestion(slide)
      return !!(fullQuestion && (fullQuestion.cpa?.outcome || fullQuestion.isCpa || fullQuestion.cpaOutcome))
    },
    getQuestionText(slide) {
      const fullQuestion = this.getFullQuestion(slide)
      if (!fullQuestion) return ''
      return fullQuestion.abstractData || fullQuestion.data || (fullQuestion.abstract && fullQuestion.abstract.data) || 'Question Data'
    },
    getSlideOptions(slide) {
      const fullQuestion = this.getFullQuestion(slide)
      if (!fullQuestion) return []
      return fullQuestion.options || null
    },
    formatIdleTime(log) {
      if (!log.idleSince) return '00:00 Mins'
      const idleStart = new Date(log.idleSince).getTime()

      let endTime = this.now

      let isStillStuck = true
      const member = this.liveTeams.flatMap((t) => t.members || []).find((m) => m.uid === log.uid)
      if (member && member.lockedPages && member.lockedPages.includes(log.pageId)) {
        isStillStuck = false
      }

      if (!isStillStuck) {
        const logTime = new Date(log.createdAt || 0).getTime()
        const answeredLog = this.activityLogs.find(
          (l) => l.uid === log.uid && l.pageId === log.pageId && l.isStuck !== true && new Date(l.createdAt || 0).getTime() > logTime
        )
        if (answeredLog) {
          endTime = new Date(answeredLog.createdAt).getTime()
        }
      }

      const diff = Math.max(0, endTime - idleStart)
      const minutes = Math.floor(diff / 60000)
      const seconds = Math.floor((diff % 60000) / 1000)
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} Mins`
    },
    formatLogTime(log) {
      if (!log.createdAt) return 'Just Now'
      const created = new Date(log.createdAt).getTime()
      const diffMins = Math.floor(Math.max(0, this.now - created) / 60000)
      if (diffMins === 0) return 'Just Now'
      return `${diffMins} mins ago`
    },
    formatLogText(log) {
      let text = log.text || ''
      this.liveTeams.forEach((team) => {
        if (!team.name) return
        const safeName = team.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        const regex = new RegExp(`\\b${safeName}\\b`, 'gi')
        text = text.replace(regex, `<span style="color: ${team.color || '#00ffff'}; text-transform: uppercase;">${team.name}</span>`)
      })
      
      // Highlight bloom level and repeat level
      text = text.replace(/\(Bloom level (\d+)\)/gi, '<b>(Bloom level $1)</b>')
      text = text.replace(/\(Repeat Level\)/gi, '<b>(Repeat Level)</b>')
      
      return text
    },
    optionText(opt) {
      return opt.val || opt.data || opt.text || opt
    },
    getAttemptedCount(slide) {
      if (!slide) return 0
      let attemptedCount = 0
      const pageId = slide.pageId || slide.page || slide.id
      this.liveTeams.forEach((t) => {
        if (t.members) {
          attemptedCount += t.members.reduce((acc, m) => {
            return acc + (m.lockedPages && m.lockedPages.includes(pageId) ? 1 : 0)
          }, 0)
        }
      })
      return attemptedCount
    },
    getPercentAttempted(slide) {
      let attemptedCount = 0
      let activeMembersCount = 0

      this.liveTeams.forEach((t) => {
        if (t.members) {
          activeMembersCount += t.members.length
          attemptedCount += t.members.reduce((acc, m) => {
            return acc + (m.lockedPages && m.lockedPages.includes(slide.pageId) ? 1 : 0)
          }, 0)
        }
      })
      if (activeMembersCount === 0) return 0
      return Math.round((attemptedCount / activeMembersCount) * 100)
    },
    getPercentStuck(slide) {
      let stuckCount = 0
      let activeMembersCount = 0
      const pageId = slide.pageId || slide.page || slide.id
      this.liveTeams.forEach((t) => {
        if (t.members) {
          activeMembersCount += t.members.length
          stuckCount += t.members.reduce((acc, m) => {
            const hasStuckLog = this.activityLogs.some((l) => l.pageId === pageId && l.uid === m.uid && l.isStuck)
            const hasCorrectAnswer = m.correctPages && m.correctPages.includes(pageId)
            return acc + (hasStuckLog && !hasCorrectAnswer ? 1 : 0)
          }, 0)
        }
      })
      if (activeMembersCount === 0) return 0
      return Math.round((stuckCount / activeMembersCount) * 100)
    },
    getPercentCorrect(slide) {
      let correctHits = 0
      let activeMembersCount = 0

      this.liveTeams.forEach((t) => {
        if (t.members) {
          activeMembersCount += t.members.length
          correctHits += t.members.reduce((acc, m) => {
            return acc + (m.correctPages && m.correctPages.includes(slide.pageId) ? 1 : 0)
          }, 0)
        }
      })

      if (activeMembersCount === 0) return 0
      return Math.round((correctHits / activeMembersCount) * 100)
    },
    getStuckCount(slide) {
      if (!slide) return 0
      let stuckCount = 0
      const pageId = slide.pageId || slide.page || slide.id
      this.liveTeams.forEach((t) => {
        if (t.members) {
          stuckCount += t.members.reduce((acc, m) => {
            const hasStuckLog = this.activityLogs.some((l) => l.pageId === pageId && l.uid === m.uid && l.isStuck)
            const hasCorrectAnswer = m.correctPages && m.correctPages.includes(pageId)
            return acc + (hasStuckLog && !hasCorrectAnswer ? 1 : 0)
          }, 0)
        }
      })
      return stuckCount
    },
    getWrongCount(slide) {
      if (!slide) return 0
      let wrongCount = 0
      const pageId = slide.pageId || slide.page || slide.id
      this.liveTeams.forEach((t) => {
        if (t.members) {
          wrongCount += t.members.reduce((acc, m) => {
            const hasAttempted = m.lockedPages && m.lockedPages.includes(pageId)
            const isCorrect = m.correctPages && m.correctPages.includes(pageId)
            return acc + (hasAttempted && !isCorrect ? 1 : 0)
          }, 0)
        }
      })
      return wrongCount
    },
    handleGroupDemo() {
      if (!this.selectedStudentSlide) return
      const targetUids = []

      const classMembers =
        (this.$store && this.$store.state && this.$store.state.teacher && this.$store.state.teacher.rooms && this.$store.state.teacher.rooms.members) || []

      if (classMembers.length > 0) {
        classMembers.forEach((m) => {
          const id = m._id || m.uid || m.id
          if (id) targetUids.push(id)
        })
      } else {
        this.liveTeams.forEach((t) => {
          if (t.members) {
            t.members.forEach((m) => {
              const id = m._id || m.uid || m.id
              if (id) targetUids.push(id)
            })
          }
        })
      }
      console.log('DEBUG: handleGroupDemo classMembers', classMembers)
      console.log('DEBUG: handleGroupDemo targetUids', targetUids)

      if (window.App && targetUids.length > 0) {
        const sid = this.session?.sid || this.$store.state.class_id
        App.service('auth').patch('syncTeacher', {
          commit: 'student/notifyTeacherRecordingVideo',
          _sid: sid,
          data: {groupDemo: true, uids: targetUids},
        })
        this.groupDemoUids = targetUids
      } else {
        this.groupDemoUids = []
        this.$message && this.$message.info('No students found to notify.')
      }
      this.showRedCaseOptionsPopup = false
      this.currentRecordingType = 'group-log'
      this.showStudentSlideView = true
    },
    getSlideUniqueId(slide, idx) {
      if (!slide) return idx !== undefined ? idx : null
      return slide.page || slide.id || slide.pageId || slide._id || (idx !== undefined ? `slide_${idx}` : null)
    },
    previewImage(picUrl) {
      if (picUrl) {
        this.previewPicUrl = picUrl
      }
    },
    async previewCpa(slide, stat, event, idx) {
      if (slide) {
        const slideId = this.getSlideUniqueId(slide, idx)
        const levelId = stat ? stat.questionId : null
        if (this.activeTooltipSlideId === slideId && this.activeTooltipLevelId === levelId) {
          this.activeTooltipSlideId = null
          this.activeTooltipLevelId = null
          this.previewCpaData = null
          return
        }
        if (event && event.currentTarget) {
          const rect = event.currentTarget.getBoundingClientRect()
          const card = event.currentTarget.closest('.gt-dashboard-card')
          if (card) {
            const parentRect = card.getBoundingClientRect()
            this.tooltipTop = rect.top - parentRect.top
          }
        }

        // Open tooltip immediately in loading state
        this.activeTooltipSlideId = slideId
        this.activeTooltipLevelId = levelId
        this.previewCpaData = null

        let abstractData = ''
        let options = []
        if (stat && stat.questionId) {
          let levelQuestion =
            this.gameConfig && this.gameConfig.questions && this.gameConfig.questions.find((q) => q._id === stat.questionId || q.id === stat.questionId)
          if ((!levelQuestion || (!levelQuestion.data && !levelQuestion.abstractData && !levelQuestion.abstract)) && window.App) {
            try {
              levelQuestion = await App.service('questions').get(stat.questionId)
            } catch (e) {
              console.error('Failed to fetch level question in previewCpa:', e)
            }
          }
          if (levelQuestion) {
            abstractData = levelQuestion.abstractData || levelQuestion.data || (levelQuestion.abstract && levelQuestion.abstract.data) || ''
            options = (levelQuestion.options || (levelQuestion.abstract && levelQuestion.abstract.options) || []).map((o) => ({
              val: o.val || o.text || o,
              on: !!o.on,
            }))
          }
        }
        if (!abstractData) {
          const fullQuestion = this.getFullQuestion(slide)
          abstractData = fullQuestion && fullQuestion.abstract && fullQuestion.abstract.data ? fullQuestion.abstract.data : ''
          options = this.getSlideOptions(slide) || []
        }

        // If the user hasn't switched tooltips or closed preview during the API call, bind the loaded data
        if (this.activeTooltipSlideId === slideId && this.activeTooltipLevelId === levelId) {
          this.previewCpaData = {
            abstractData,
            options,
          }
        }
      }
    },
    hasPostGameDemo(slide, questionId = null) {
      const _ = this.demoUpdateKey
      if (!slide || !this.gameConfig || !this.gameConfig.gameOnRecord || !this.gameConfig.gameOnRecord.postGameDemos) return false

      const demos = this.gameConfig.gameOnRecord.postGameDemos
      if (questionId) {
        return demos.includes(questionId)
      }

      const slideId = slide.pageId || slide.page || slide.id
      return demos.includes(slideId)
    },
    async openPostGameDemo(slide, stat) {
      if (!slide) return

      const pageId = slide.page || slide.id
      let levelQuestion = null
      if (stat && stat.questionId) {
        levelQuestion =
          this.gameConfig && this.gameConfig.questions && this.gameConfig.questions.find((q) => q._id === stat.questionId || q.id === stat.questionId)
        if ((!levelQuestion || (!levelQuestion.data && !levelQuestion.abstractData && !levelQuestion.abstract)) && window.App) {
          try {
            levelQuestion = await App.service('questions').get(stat.questionId)
          } catch (e) {
            console.error('Failed to fetch level question in openPostGameDemo:', e)
          }
        }
      }
      const fullQuestion = levelQuestion || this.getFullQuestion(slide) || {}

      let pic = slide.pic || fullQuestion.pic || ''
      if (!pic && this.$store && this.$store.getters && this.$store.getters.getPageById) {
        const normalizedPageId = pageId && typeof pageId === 'string' && pageId.startsWith('p-') ? pageId.replace('p-', '') : pageId
        const pageData = this.$store.getters.getPageById(pageId) || this.$store.getters.getPageById(normalizedPageId)
        if (pageData && pageData.pic) {
          pic = pageData.pic
        }
      }

      const baseQuestion = this.getFullQuestion(slide) || {}
      this.selectedStudentSlide = {
        ...slide,
        ...fullQuestion,
        id: stat ? stat.questionId : slide.page || slide.id || slide.pageId,
        page: stat ? stat.questionId : slide.page || slide.id || slide.pageId,
        isPostGameDemoCpa: !!stat,
        bloom_questions: baseQuestion.bloom_questions || baseQuestion.cpa?.bloom_questions,
        pic,
      }
      this.activeCpaStat = stat
      this.isRedoDemo = this.hasPostGameDemo(slide, stat ? stat.questionId : null)

      const targetUids = []
      const classMembers =
        (this.$store && this.$store.state && this.$store.state.teacher && this.$store.state.teacher.rooms && this.$store.state.teacher.rooms.members) || []

      if (classMembers.length > 0) {
        classMembers.forEach((m) => {
          targetUids.push(m._id || m.uid || m.id)
        })
      } else {
        this.liveTeams.forEach((t) => {
          if (t.members) {
            t.members.forEach((m) => {
              targetUids.push(m.uid)
            })
          }
        })
      }

      this.groupDemoUids = targetUids
      this.currentRecordingType = 'analyticsDemo'
      this.isPostGameDemo = true
      this.startDemoType = 'analyticsDemo'
      this.showStartDemoPopup = true
    },
    toggleDashboardCard(idx) {
      this.$set(this.expandedDashboardCards, idx, !this.expandedDashboardCards[idx])
    },
    closePreview() {
      this.previewPicUrl = null
      this.activeTooltipSlideId = null
      this.activeTooltipLevelId = null
      this.previewCpaData = null
    },
    getStudentName(studentId) {
      if (!studentId) return ''
      const classMembers =
        (this.$store && this.$store.state && this.$store.state.teacher && this.$store.state.teacher.rooms && this.$store.state.teacher.rooms.members) || []
      const member = classMembers.find((m) => (m._id || m.uid || m.id) === studentId)
      if (member) {
        return member.nickname || member.name || member.username || ''
      }
      for (const team of this.liveTeams) {
        if (team.members) {
          const m = team.members.find((m) => m.uid === studentId)
          if (m) {
            return m.nickname || m.name || m.username || ''
          }
        }
      }
      return ''
    },
    async openStudentSlideView(log, isRedo = false) {
      if (!log || !log.pageId) return

      console.log('logggg', log)

      const pageId = log.pageId
      const normalizedPageId = pageId.includes('::') ? pageId.split('::')[1] : pageId

      let slide = this.gameConfig.slides.find(
        (s) =>
          s.page === pageId ||
          s.id === pageId ||
          s.page === normalizedPageId ||
          s.id === normalizedPageId ||
          (s.page && s.page.includes(normalizedPageId)) ||
          (s.id && s.id.includes(normalizedPageId))
      )

      if (!slide) slide = {id: pageId, page: pageId}

      let levelQuestion = null
      if (log.questionId) {
        const allQuestions = (this.gameConfig && this.gameConfig.questions) || (this.session && this.session.questions) || []
        levelQuestion = allQuestions.find((q) => q._id === log.questionId || q.id === log.questionId)
        if ((!levelQuestion || (!levelQuestion.abstract && !levelQuestion.data)) && window.App) {
          try {
            levelQuestion = await App.service('questions').get(log.questionId)
          } catch (e) {
            console.error('Failed to fetch level question in openStudentSlideView:', e)
          }
        }
      }

      const fullQuestion = levelQuestion || this.getFullQuestion(slide) || {}

      let pic = slide.pic || fullQuestion.pic || ''
      if (!pic && this.$store && this.$store.getters && this.$store.getters.getPageById) {
        const pageData = this.$store.getters.getPageById(pageId) || this.$store.getters.getPageById(normalizedPageId)
        if (pageData && pageData.pic) {
          pic = pageData.pic
        }
      }

      this.selectedStudentSlide = {...slide, ...fullQuestion, pic, questionId: log.questionId}
      this.selectedStudentId = log.uid
      this.selectedLogId = log.id || log._id
      this.selectedActivityLog = log
      this.isRedCase = log.wrongAnswers >= 1 || (log.text && log.text.includes('incorrectly'))
      this.isYellowCase = log.isStuck === true
      this.isRedoDemo = !!(isRedo || log.resolved)

      if (this.isRedCase || this.isYellowCase) {
        this.showTeacherCheckAnswerPopup = true
      } else {
        this.showStudentSlideView = true
      }

      // NEW: Sync to session for projector view
      if (this.isDashboard) {
        try {
          this.$store.dispatch('upSession', {
            slideSupportData: this.selectedStudentSlide,
            slideSupportUid: this.selectedStudentId,
          })
        } catch (e) {
          console.error('Failed to sync slideSupportData to session:', e)
        }
      }
    },
    closeStudentSlideView() {
      if (!this.isRedCase && !this.isYellowCase && window.App && this.selectedStudentId) {
        App.service('auth')
          .patch('syncTeacher', {
            commit: 'student/closeSlideSupport',
            data: {uid: this.selectedStudentId},
          })
          .catch((e) => console.error('Failed to emit closeSlideSupport:', e))
      }

      this.showStudentSlideView = false
      this.selectedStudentSlide = null
      this.selectedStudentId = null
      this.isPostGameDemo = false
      this.isRedoDemo = false
      this.activeCpaStat = null
      this.isRedCase = false
      this.isYellowCase = false
      this.isReviewOnlyMode = false
      this.currentRecordingType = 'feedback'

      // NEW: Clear from session for projector view
      if (this.isDashboard) {
        try {
          this.$store.dispatch('upSession', {
            slideSupportData: null,
            slideSupportUid: null,
          })
        } catch (e) {
          console.error('Failed to clear slideSupportData from session:', e)
        }
      }
    },
    getCpaBloomStats(slide) {
      const fullQuestion = this.getFullQuestion(slide)
      const BloomLabels = ['REMEMBER', 'UNDERSTAND', 'APPLY', 'ANALYZE', 'EVALUATE', 'CREATE']

      let questionsToProcess = []

      if (fullQuestion && fullQuestion.bloom_questions) {
        Object.entries(fullQuestion.bloom_questions).forEach(([key, qId]) => {
          questionsToProcess.push({
            id: qId,
            bloomValue: parseInt(key) + 1,
          })
        })
      } else {
        questionsToProcess.push({
          id: fullQuestion ? fullQuestion._id || fullQuestion.id || slide.page : slide.page,
          bloomValue: fullQuestion && fullQuestion.bloom && fullQuestion.bloom.length > 0 ? fullQuestion.bloom[0] : 4,
        })
      }

      return questionsToProcess.map((q) => {
        let attemptCount = 0
        let correctHits = 0
        let stuckCount = 0
        let activeMembersCount = 0

        this.liveTeams.forEach((t) => {
          if (t.members) {
            t.members.forEach((m) => {
              activeMembersCount++

              const isCpaQuestion = !!(fullQuestion && fullQuestion.bloom_questions && Object.keys(fullQuestion.bloom_questions).length > 0)
              const isRootQuestion = fullQuestion && (q.id === fullQuestion._id || q.id === fullQuestion.id)

              let isAttempted = false
              let isCorrect = false
              let hasStuckLog = false

              if (isCpaQuestion) {
                isAttempted = !!(m.lockedQuestionIds && m.lockedQuestionIds.includes(q.id))
                isCorrect = !!(m.correctQuestionIds && m.correctQuestionIds.includes(q.id))
                hasStuckLog = !!(this.activityLogs && this.activityLogs.some((l) => l.questionId === q.id && l.uid === m.uid && l.isStuck))
              } else {
                isAttempted =
                  (m.lockedPages &&
                    m.lockedPages.some((pageId) => {
                      return pageId === q.id || (isRootQuestion && (pageId === slide.page || pageId === slide.id))
                    })) ||
                  (m.lockedQuestionIds && m.lockedQuestionIds.includes(q.id))
                isCorrect =
                  (m.correctPages &&
                    m.correctPages.some((pageId) => {
                      return pageId === q.id || (isRootQuestion && (pageId === slide.page || pageId === slide.id))
                    })) ||
                  (m.correctQuestionIds && m.correctQuestionIds.includes(q.id))
                hasStuckLog =
                  this.activityLogs &&
                  this.activityLogs.some(
                    (l) =>
                      (l.pageId === q.id || l.questionId === q.id || (isRootQuestion && (l.pageId === slide.page || l.pageId === slide.id))) &&
                      l.uid === m.uid &&
                      l.isStuck
                  )
              }
              const isStuck = hasStuckLog && !isCorrect

              if (isAttempted) {
                attemptCount++
              }
              if (isCorrect) {
                correctHits++
              }
              if (isStuck) {
                stuckCount++
              }
            })
          }
        })

        let wrongHits = attemptCount - correctHits
        let bloomValue = q.bloomValue
        let levelName = BloomLabels[bloomValue - 1] || 'ANALYZE'
        let levelPrefix = `LEVEL ${bloomValue} : `

        return {
          questionId: q.id,
          levelPrefix: levelPrefix,
          levelName: levelName,
          levelNum: bloomValue,
          levelNameFormated: levelName.charAt(0).toUpperCase() + levelName.slice(1).toLowerCase(),
          attempt: attemptCount,
          correct: correctHits,
          stuck: stuckCount,
          wrong: wrongHits,
        }
      })
    },
    async handleZoomClick() {
      if (this.session.sid) {
        localStorage.setItem('meeting_active_' + this.session.sid, 'true')
        localStorage.removeItem('meeting_stopped_at_' + this.session.sid)
      }
      await this.$store.dispatch('upSession', {lastMeetingHeartbeat: Date.now()})
      const userName = this.user?.nickname || this.user?.name || ''

      // Activate embedded meeting sidebar via Vuex store
      this.$store.commit('setMeeting', {
        active: true,
        minimized: false,
        name: userName,
        sid: this.session.sid,
        sessionId: this.session._id,
        audioMuted: true,
        videoMuted: true,
        isTeacher: true,
      })
    },
    onMeetingLeft() {
      this.$store.commit('setMeeting', {active: false, minimized: false, name: '', sid: '', audioMuted: true, videoMuted: true})
    },
    onStorageChange(e) {
      if (e.key === 'meeting_active_' + this.session.sid || e.key === 'meeting_stopped_at_' + this.session.sid) {
        this.updateLocalState()
      }
    },
    updateLocalState() {
      this.isLocalMeetingActive = localStorage.getItem('meeting_active_' + this.session.sid) === 'true'
      const stoppedAt = Number(localStorage.getItem('meeting_stopped_at_' + this.session.sid))
      this.isLocalMeetingStoppedRecently = !!(stoppedAt && Date.now() - stoppedAt < 60000)

      if (this.isMeetingOngoing && (!this.meeting || !this.meeting.active)) {
        this.$store.commit('setMeeting', {
          active: true,
          minimized: false,
          name: this.user?.nickname || this.user?.name || 'Teacher',
          sid: this.session.sid,
          sessionId: this.session._id,
          audioMuted: true,
          videoMuted: true,
          isTeacher: true,
        })
      }

      // Self-healing: if localStorage says meeting is active but the server heartbeat
      // has expired (no update for 30+ seconds) or was never set, clear the stale flag
      if (this.isLocalMeetingActive) {
        if (!this.session?.lastMeetingHeartbeat) {
          // No heartbeat at all — meeting is definitely not active
          localStorage.removeItem('meeting_active_' + this.session.sid)
          this.isLocalMeetingActive = false
        } else {
          const elapsed = this.now - this.session.lastMeetingHeartbeat
          if (elapsed >= 30000) {
            console.log('[Meeting] Clearing stale meeting_active localStorage flag (heartbeat expired)')
            localStorage.removeItem('meeting_active_' + this.session.sid)
            this.isLocalMeetingActive = false
          }
        }
      }
    },
    closeRedCaseOptionsPopup() {
      this.showRedCaseOptionsPopup = false
      this.selectedStudentSlide = null
      this.selectedStudentId = null
      this.isRedCase = false
      this.isYellowCase = false
      this.isReviewOnlyMode = false
    },
    closeInterventionInitialPopup() {
      this.showInterventionInitialPopup = false
      this.selectedStudentSlide = null
      this.selectedStudentId = null
      this.selectedActivityLog = null
      this.isRedCase = false
      this.isYellowCase = false
      this.isReviewOnlyMode = false
    },
    closeTeacherCheckAnswerPopup() {
      this.showTeacherCheckAnswerPopup = false
      this.selectedStudentSlide = null
      this.selectedStudentId = null
      this.selectedActivityLog = null
      this.isRedCase = false
      this.isYellowCase = false
      this.isReviewOnlyMode = false
    },
    handleHelpStudentFromCheckAnswer() {
      this.showTeacherCheckAnswerPopup = false
      this.showInterventionInitialPopup = true
    },
    async handleMarkStudentAnswerCorrect() {
      const log = this.selectedActivityLog
      const slide = this.selectedStudentSlide
      const logId = log ? log.id || log._id : null
      const gameId = this.gameConfig && this.gameConfig.gameOnRecord ? this.gameConfig.gameOnRecord._id : null
      const pageId = slide ? slide.page || slide.id || slide.pageId : null
      const questionId = slide ? slide.questionId || slide._id : null
      const studentUid = this.selectedStudentId

      this.showTeacherCheckAnswerPopup = false

      if (window.App && App.service('game-on')) {
        try {
          await App.service('game-on').get('markStudentAnswerCorrect', {
            query: {
              logId,
              _id: gameId,
              pageId,
              questionId,
              studentUid,
            },
          })

          // Mark targeted log as resolved locally
          if (this.activityLogs && this.activityLogs.length) {
            this.activityLogs.forEach((l) => {
              const matchLogId = logId && (l.id === logId || l._id === logId)
              const matchQuestionId = questionId && l.questionId === questionId
              const matchPageId = !logId && !questionId && pageId && l.pageId === pageId
              if (l && l.uid === studentUid && (matchLogId || matchQuestionId || matchPageId)) {
                l.resolved = true
                l.color = '#22c55e'
                l.iconClass = 'fa-check-circle'
              }
            })
          }
          this.$message && this.$message.success('Student’s answer marked as correct!')
        } catch (err) {
          console.error('Failed to mark student answer correct:', err)
          this.$message && this.$message.error('Failed to mark student answer as correct')
        }
      }

      this.selectedStudentSlide = null
      this.selectedStudentId = null
      this.selectedActivityLog = null
      this.isRedCase = false
      this.isYellowCase = false
      this.isReviewOnlyMode = false
    },
    async handleDemoSent(question) {
      if (!question || !this.isPostGameDemo) return

      const pageId = question._id || question.id || question.questionId || question.page || question.pageId
      if (!this.gameConfig || !this.gameConfig.gameOnRecord) return

      let postGameDemos = this.gameConfig.gameOnRecord.postGameDemos ? [...this.gameConfig.gameOnRecord.postGameDemos] : []
      if (!postGameDemos.includes(pageId)) {
        postGameDemos.push(pageId)

        // Update local state so it immediately shows Re-do Demo
        this.$set(this.gameConfig.gameOnRecord, 'postGameDemos', postGameDemos)
        this.demoUpdateKey += 1

        // Patch to server
        if (window.App && this.gameConfig.gameOnRecord._id) {
          try {
            await App.service('game-on').patch(this.gameConfig.gameOnRecord._id, {
              postGameDemos,
            })
            console.log('DEBUG: Patched postGameDemos:', postGameDemos)
          } catch (err) {
            console.error('Failed to update postGameDemos:', err)
          }
        }
      }
    },
    handleReviewAction() {
      this.showInterventionInitialPopup = false
      this.isReviewOnlyMode = true
      this.showStudentSlideView = true
    },
    handleDemoAction() {
      this.showInterventionInitialPopup = false
      this.isReviewOnlyMode = false
      this.showRedCaseOptionsPopup = true
    },
    handleDemoOptionClick(type) {
      this.startDemoType = type
      this.showRedCaseOptionsPopup = false
      this.showStartDemoPopup = true
    },
    async onStartDemo() {
      this.showStartDemoPopup = false
      if (!this.isMeetingOngoing) {
        await this.handleZoomClick()
      }
      if (this.startDemoType === 'live-log') {
        this.handleInviteStudent()
      } else if (this.startDemoType === 'group-log') {
        this.handleGroupDemo()
      } else if (this.startDemoType === 'parellel-log') {
        this.openReviewRecordingsPopup()
      } else if (this.startDemoType === 'analyticsDemo') {
        this.showStudentSlideView = true
      }
    },
    handleInviteStudent() {
      if (window.App && this.selectedStudentId) {
        const sid = this.session?.sid || this.$store.state.class_id
        App.service('auth').patch('syncTeacher', {
          commit: 'student/notifyJoinTeacherRoom',
          _sid: sid,
          data: {uid: this.selectedStudentId},
        })

        App.service('auth').patch('syncTeacher', {
          commit: 'student/notifyTeacherRecordingVideo',
          _sid: sid,
          data: {uid: this.selectedStudentId},
        })

        this.$message && this.$message.success('Invite sent to student')
      }
      this.showRedCaseOptionsPopup = false

      this.currentRecordingType = 'live-log'
      this.showStudentSlideView = true
    },
    async openReviewRecordingsPopup() {
      this.showRedCaseOptionsPopup = false
      this.isFetchingRecordings = true
      this.reviewRecordingsList = []

      try {
        const teacherUid = this.$store?.state?.user?._id || ''
        const slideId =
          this.selectedStudentSlide?.questionId || this.selectedStudentSlide?.page || this.selectedStudentSlide?.id || this.selectedStudentSlide?._id || ''

        if (window.App) {
          const res = await App.service('review-recording').find({
            query: {
              questionId: slideId,
              type: 'parellel-log',
              $sort: {createdAt: -1},
            },
          })

          let recordings = res.data || res || []

          if (recordings.length === 0) {
            this.createCustomFeedbackWorkflow()
            return
          }

          // Fetch user details for each recording using the uid
          const uids = [...new Set(recordings.map((r) => r.uid))]
          if (uids.length > 0) {
            const usersRes = await App.service('users').find({
              query: {
                _id: {$in: uids},
                $select: ['_id', 'name', 'nickname'],
              },
            })
            const usersData = usersRes.data || usersRes || []
            const userMap = {}
            usersData.forEach((u) => {
              userMap[u._id] = u
            })

            recordings = recordings.map((r) => {
              let tName = userMap[r.uid]?.name || userMap[r.uid]?.nickname || 'Teacher'
              if (Array.isArray(tName)) {
                tName = tName.join(' ')
              }
              return {
                ...r,
                fetchedTeacherName: tName,
              }
            })
          }

          this.reviewRecordingsList = recordings
          this.showReviewRecordingsPopup = true
        } else {
          this.createCustomFeedbackWorkflow()
        }
      } catch (err) {
        console.error('Failed to fetch review recordings', err)
        this.createCustomFeedbackWorkflow()
      } finally {
        this.isFetchingRecordings = false
      }
    },
    closeReviewRecordingsPopup() {
      this.showReviewRecordingsPopup = false
      this.reviewRecordingsList = []
      this.selectedRecordingId = null
      this.selectedStudentSlide = null
      this.selectedStudentId = null
      this.previewVideoUrl = null
    },
    async applyExistingFeedback(recording) {
      if (!recording || !recording._id) return

      try {
        if (window.App) {
          await App.service('game-on-feedback').create({
            uid: this.selectedStudentId,
            reviewRecordingId: recording._id,
          })

          const sid = this.gameConfig?.gameOnRecord?.sessionId || this.$store?.state?.session?.sid || this.$store?.state?.class_id || this.$route?.params?.id
          const gameRoomId = this.gameConfig?.gameOnRecord?._id || this.roomId

          if (gameRoomId && App.service('game-on')) {
            App.service('game-on')
              .get('sendRecordingNotification', {
                query: {
                  roomId: gameRoomId,
                  groupDemo: false,
                  uids: [this.selectedStudentId],
                  uid: this.selectedStudentId,
                  reviewRecordingId: recording._id,
                },
              })
              .catch((err) => console.warn('Failed to send game-on recording notification:', err))
          }

          if (sid && App.service('auth')) {
            App.service('auth')
              .patch('syncTeacher', {
                commit: 'student/notifyRecordingReceived',
                _sid: sid,
                data: {uid: this.selectedStudentId},
              })
              .catch((err) => console.warn('Failed to send auth recording notification:', err))
          }

          this.$message && this.$message.success('Feedback sent to student successfully!')
          this.handleDemoSent(this.selectedStudentSlide)
        }
      } catch (err) {
        console.error('Failed to send game-on-feedback', err)
        this.$message && this.$message.error('Failed to send feedback')
      }
      this.closeReviewRecordingsPopup()
    },
    applySelectedFeedback() {
      if (!this.selectedRecordingId) return
      const rec = this.reviewRecordingsList.find((r) => r._id === this.selectedRecordingId)
      if (rec) {
        this.applyExistingFeedback(rec)
      }
    },
    createCustomFeedbackWorkflow() {
      this.showReviewRecordingsPopup = false
      this.currentRecordingType = 'parellel-log'
      this.groupDemoUids = []
      this.showStudentSlideView = true
    },
    handleVideoLoadedMetadata(event, videoUrl) {
      const duration = event.target?.duration
      if (duration) {
        const minutes = Math.floor(duration / 60)
        const seconds = Math.floor(duration % 60)
        this.$set(this.videoDurations, videoUrl, `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`)
      }
    },
    async markLogAsResolved() {
      if (this.selectedLogId) {
        const log = this.activityLogs.find((l) => l.id === this.selectedLogId || l._id === this.selectedLogId)
        if (log && !log.resolved) {
          log.resolved = true
          if (window.App && App.service('game-on-log')) {
            App.service('game-on-log')
              .patch(log.id || log._id, {resolved: true})
              .catch((e) => console.error(e))
          }
        }
      }
    },
  },
}
</script>

<style scoped>
.gt-overlay {
  position: relative;
  flex: 1;
  width: auto;
  height: 100%;
  background: #f4f7fa;
  color: #1e293b;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  z-index: 100000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.gt-overlay.gt-projector-bg {
  background-image: url('https://r2.classcipe.com/5ba969ff64d08ea536f0b56648c9f7be2d8343db');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.gt-projector-bg .gt-header {
  background: transparent;
  border-bottom: none;
}
.gt-projector-bg .gt-header-left {
  color: #fff;
}
.gt-projector-bg .gt-header-left i {
  color: #fff;
}
.gt-projector-bg .gt-left-panel {
  background: transparent;
  border-right: none;
}
.gt-projector-bg .gt-timer-box {
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}
.gt-projector-bg .gt-timer-label {
  color: #475569;
}
.gt-projector-bg .gt-btn-end {
  background: #de3163;
  color: #fff;
  border: none;
}
.gt-projector-bg .gt-btn-end:hover {
  background: #c22b56;
}
.gt-projector-bg .gt-lb-card {
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  border-right: 1px solid rgba(255, 255, 255, 0.3);
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}
.gt-projector-bg .gt-section-title {
  color: rgba(255, 255, 255, 0.8);
}
.gt-projector-bg .gt-race-track {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  width: 95%;
  height: 85%;
  margin: auto;
}

.gt-header {
  height: 50px;
  background: #0f172a;
  border-bottom: none;
  display: flex;
  align-items: center;
  padding: 0 24px;
}
.gt-header-left {
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 1px;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 12px;
}

.gt-main {
  flex: 1;
  display: flex;
  overflow: hidden;
}

/* LEFT PANEL */
.gt-left-panel {
  width: 240px;
  background: #ffffff;
  border-right: 1px solid #e0e5eb;
  display: flex;
  flex-direction: column;
  padding: 16px;
  box-sizing: border-box;
}
.gt-timer-box {
  background: #ffffff;
  border: 1px solid #e0e5eb;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  margin-bottom: 30px;
}
.gt-timer-label {
  font-size: 11px;
  color: #6b7280;
  letter-spacing: 1px;
  margin-bottom: 10px;
  font-weight: bold;
}
.gt-timer-value {
  font-size: 32px;
  color: #d9214e;
  font-weight: bold;
  margin-bottom: 15px;
}
.gt-dashboard-card-header {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.gt-view-btn {
  color: #00ffff;
  font-size: 10px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  transition: opacity 0.2s;
}
.gt-view-btn i {
  font-size: 14px;
}
.gt-view-btn:hover {
  opacity: 0.8;
}
.gt-cpa-question-text {
  color: #fff;
  font-size: 12px;
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 4px;
  min-height: 42px;
  padding: 0 4px;
}
.gs-cpa-close {
  position: absolute;
  top: 16px;
  right: 20px;
  color: #8c99a0;
  font-size: 16px;
  cursor: pointer;
  transition: color 0.2s;
  z-index: 10;
}
.gs-cpa-close:hover {
  color: #fff;
}
.gs-cpa-modal {
  background: #0d2729;
  border: 1px solid #00ffff;
  border-radius: 8px;
  padding: 32px;
  font-size: 14px;
  color: #fff;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.8);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  position: relative;
}
.gs-cpa-question {
  margin-bottom: 12px;
  line-height: 1.4;
  padding-right: 24px;
}
.gs-cpa-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.gs-cpa-option {
  display: flex;
  align-items: flex-start;
  line-height: 1.4;
}
.gs-cpa-tick {
  color: #00e676;
  margin-right: 8px;
  margin-top: 3px;
  font-size: 11px;
  width: 14px;
}
.gs-cpa-indent {
  margin-left: 22px;
}
.gs-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100000;
}
.gs-preview-image {
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.8);
  border: 1px solid #1a3c40;
}
.gs-preview-close {
  position: absolute;
  top: 30px;
  right: 30px;
  color: #8c99a0;
  font-size: 25px;
  cursor: pointer;
  transition: color 0.2s;
  z-index: 100001;
}
.gs-preview-close:hover {
  color: #fff;
}
.gs-cpa-tooltip {
  position: absolute;
  top: 100%;
  width: 320px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  z-index: 10000;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.02);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #334155;
  cursor: default;
  margin-top: 8px;
}
.gs-cpa-tooltip-left {
  left: 0;
}
.gs-cpa-tooltip-right {
  right: 0;
}
.gs-cpa-tooltip-question {
  margin-bottom: 12px;
  line-height: 1.4;
  font-size: 11px;
  color: #0f172a;
  font-weight: 500;
}
.gs-cpa-tooltip-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 11px;
}
.gs-cpa-tooltip-option {
  display: flex;
  align-items: flex-start;
  line-height: 1.4;
}
.gs-cpa-tooltip-tick {
  color: #10b981;
  margin-right: 8px;
  margin-top: 3px;
  font-size: 11px;
  width: 14px;
}
.gs-cpa-tooltip-indent {
  margin-left: 22px;
}
.gt-bloom-table-container {
  flex: 1;
  overflow: auto;
  margin-top: 8px;
  min-height: 0;
  padding-right: 4px;
}
.gt-bloom-table-container::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
.gt-bloom-table-container::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
}
.gt-bloom-table {
  width: 100%;
}
.gt-bloom-header {
  display: flex;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  margin-bottom: 8px;
  text-transform: uppercase;
}
.gt-bloom-header > div {
  font-size: 9px !important;
  color: #e2e8f0;
  font-weight: bold;
  letter-spacing: 1.5px;
}
.gt-bloom-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.gt-bloom-row {
  display: flex;
  align-items: center;
  background: rgba(12, 12, 12, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.05);
  padding: 12px;
  border-radius: 6px;
}

.gt-section-title {
  font-size: 10px;
  color: #6b7280;
  letter-spacing: 1px;
  font-weight: bold;
  margin-bottom: 16px;
  text-transform: uppercase;
}

.gt-leaderboard {
  flex: 1;
  overflow-y: auto;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.gt-lb-card {
  display: flex;
  align-items: center;
  background: #f8fafc;
  border-left: 4px solid;
  border-radius: 8px;
  padding: 12px 16px;
}
.gt-lb-rank {
  font-size: 14px;
  font-weight: bold;
  width: 30px;
}
.gt-lb-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.gt-lb-name {
  font-size: 11px;
  font-weight: bold;
  text-transform: uppercase;
}
.gt-lb-avatars {
  display: flex;
  margin-left: 6px;
}
.gt-avatar {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-size: 7px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #fff;
  margin-left: -6px;
  font-weight: bold;
}
.gt-avatar:first-child {
  margin-left: 0;
}
.gt-lb-score {
  text-align: right;
}
.gt-lb-points {
  font-size: 14px;
  font-weight: bold;
}
.gt-lb-points-label {
  font-size: 9px;
  color: #94a3b8;
  letter-spacing: 1px;
}

.gt-recent-activity {
  background: rgba(18, 30, 36, 0.5);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
}

.gt-btn-end {
  width: 100%;
  background: transparent;
  color: #ef4444;
  border: 1px solid #ef4444;
  padding: 10px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  cursor: pointer;
  transition: 0.2s;
}
.gt-btn-end:hover {
  background: #fef2f2;
}

/* CENTER PANEL */
.gt-center-panel {
  flex: 1;
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 0 40px;
  box-sizing: border-box;
  background: transparent;
  z-index: 5;
}

/* DASHBOARD SLIDE VIEWER — override the flex alignment */
.gt-center-slides {
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  padding: 0;
  margin-top: 15px;
  z-index: 10;
  overflow-y: auto;
}

/* Progress tabs bar */
.gt-slides-progress {
  display: flex;
  background: rgba(7, 25, 29, 0.4);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  overflow-x: auto;
  flex-shrink: 0;
}
.gt-slide-tab {
  flex: 1;
  min-width: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 10px 8px 8px;
  transition: background 0.2s;
  position: relative;
}
.gt-slide-tab:hover {
  background: #0d2525;
}
.gt-slide-tab-bar {
  width: 100%;
  height: 3px;
  background: #1a3c40;
  border-radius: 2px;
  margin-bottom: 6px;
  transition: background 0.25s;
}
.gt-slide-tab.active .gt-slide-tab-bar {
  background: #00ffff;
  box-shadow: 0 0 8px rgba(0, 255, 255, 0.7);
}
.gt-slide-tab-label {
  font-size: 9px;
  color: #8c99a0;
  letter-spacing: 0.5px;
  font-weight: bold;
  white-space: nowrap;
}
.gt-slide-tab.active .gt-slide-tab-label {
  color: #00ffff;
}

/* Navigation row */
.gt-slide-nav-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 24px;
  background: rgba(9, 19, 21, 0.4);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  flex-shrink: 0;
}
.gt-slide-nav-btn {
  background: transparent;
  border: none;
  color: #8c99a0;
  font-size: 10px;
  font-weight: bold;
  letter-spacing: 1px;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 4px;
  transition: color 0.2s, background 0.2s;
}
.gt-slide-nav-btn:hover:not(:disabled) {
  color: #00ffff;
  background: #0d2525;
}
.gt-slide-nav-btn:disabled {
  opacity: 0.3;
  cursor: default;
}
.gt-slide-question-title {
  font-size: 14px;
  font-weight: bold;
  color: #00ffff;
  letter-spacing: 2px;
  text-shadow: 0 0 10px rgba(0, 255, 255, 0.4);
}
.gt-btn-analyse {
  background: transparent;
  border: 1px solid #00ffff;
  color: #00ffff;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 9px;
  font-weight: bold;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.2s;
}
.gt-btn-analyse:hover {
  background: rgba(0, 255, 255, 0.1);
  box-shadow: 0 0 10px rgba(0, 255, 255, 0.2);
}

/* Slide image area */
.gt-slide-preview-area {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
}
.gt-slide-image {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 8px;
}
.gt-slide-no-image {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #0c161a;
  border: 1px dashed #1a3c40;
  border-radius: 8px;
}

.gt-race-track {
  width: 100%;
  height: 80%;
  display: flex;
  justify-content: space-around;
  position: relative;
}
.gt-rocket-lane {
  position: relative;
  width: 60px;
  height: 100%;
  display: flex;
  justify-content: center;
}
.gt-rocket-wrapper {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: bottom 1s cubic-bezier(0.25, 0.8, 0.25, 1);
}

@keyframes rocketVibrate {
  0% {
    transform: translateX(0);
  }
  15% {
    transform: translateX(-3px) rotate(-1deg);
  }
  30% {
    transform: translateX(3px) rotate(1deg);
  }
  45% {
    transform: translateX(-2px) rotate(-0.5deg);
  }
  60% {
    transform: translateX(2px) rotate(0.5deg);
  }
  75% {
    transform: translateX(-1px);
  }
  100% {
    transform: translateX(0);
  }
}

.rocket-moving {
  animation: rocketVibrate 0.15s ease-in-out infinite;
}
.gt-rocket-label {
  border: 1px solid;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 9px;
  font-weight: bold;
  background: rgba(9, 19, 21, 0.6);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  margin-bottom: 12px;
  white-space: nowrap;
}
.gt-rocket-icon {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
}
.gt-rocket-tail {
  position: absolute;
  top: 90%;
  left: 50%;
  transform: translateX(-50%);
  width: 6px;
  height: 200px;
  border-radius: 3px;
  z-index: 1;
  filter: blur(2px);
  opacity: 0.8;
  transition: all 1.5s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.rocket-finished .rocket-svg {
  width: 140px;
  transform: translateY(-20px);
  filter: drop-shadow(0 0 25px currentColor);
}
.rocket-finished .gt-rocket-tail {
  width: 14px;
  height: 400px;
  filter: blur(4px);
  opacity: 1;
}

/* RIGHT PANEL */
.gt-right-panel {
  width: 240px;
  background: #ffffff;
  border-left: 1px solid #e0e5eb;
  display: flex;
  flex-direction: column;
  padding: 16px;
  box-sizing: border-box;
}
.gt-log-header {
  color: #64748b;
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 10px;
  text-transform: uppercase;
}

.gt-log-header div {
  font-size: 11px;
}
.gt-log-list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.gt-log-item {
  background: #ffffff;
  border: 1px solid #f1f5f9;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
  transition: transform 0.2s, box-shadow 0.2s;
}
.gt-log-clickable {
  cursor: pointer;
}
.gt-log-clickable:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px -2px rgba(0, 0, 0, 0.05);
}
.gt-log-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 8px;
  flex-wrap: wrap;
}
.gt-log-item-body {
  color: #475569;
  line-height: 1.5;
}
.gt-log-item-body,
.gt-log-item-body * {
  font-size: 11px !important;
}
.gt-log-item-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
}
.gt-log-action-btn {
  background: #0f172a;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: background 0.2s;
}
.gt-log-action-btn:hover {
  background: #1e293b;
}
.gt-log-processing {
  text-align: center;
  padding: 20px;
  color: #94a3b8;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1px;
}

/* DASHBOARD GRID & CARDS */
.gt-dashboard-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  align-content: flex-start;
}
.gt-dashboard-card {
  background: rgba(15, 28, 33, 0.45);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  height: 350px;
  min-width: 0;
}
.gt-dashboard-card-header {
  padding: 14px 16px;
  background: rgba(5, 14, 18, 0.95);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.gt-dashboard-card-footer {
  padding: 14px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(5, 14, 18, 0.95);
}

.gt-rocket-avatar {
  position: absolute;
  top: 90px;
  left: 50%;
  transform: translateX(-50%);
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid;
  background: rgba(9, 19, 21, 0.6);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 9px;
  font-weight: bold;
  color: #fff;
  z-index: 4;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  animation: popIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.gt-rocket-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.gt-avatar-tooltip {
  position: absolute;
  bottom: -22px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(9, 19, 21, 0.9);
  border: 1px solid;
  border-radius: 4px;
  padding: 4px 6px;
  font-size: 11px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s;
  pointer-events: none;
  z-index: 5;
}
.gt-rocket-avatar:hover .gt-avatar-tooltip {
  opacity: 1;
  visibility: visible;
}

.rocket-svg {
  width: 80px;
  height: auto;
  display: block;
  will-change: transform, width, filter;
  filter: drop-shadow(0 0 10px currentColor);
  transition: all 1.5s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.gt-rocket-wrapper:not(.rocket-moving) .rocket-svg {
  animation: idle-thrum 3s ease-in-out infinite;
}

@keyframes idle-thrum {
  0%,
  100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, -6px);
  }
}

@keyframes popIn {
  0% {
    transform: translateX(-50%) scale(0);
    opacity: 0;
  }
  100% {
    transform: translateX(-50%) scale(1);
    opacity: 1;
  }
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: #1a3c40;
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background: #33ffff;
}

.gt-score-popup {
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  color: #00ffff;
  font-weight: bold;
  font-size: 19px;
  text-shadow: 0 0 10px rgba(0, 255, 255, 0.8), 0 0 20px rgba(0, 255, 255, 0.4);
  animation: scoreFloatUp 2s forwards;
  pointer-events: none;
  z-index: 10;
}

@keyframes scoreFloatUp {
  0% {
    transform: translate(-50%, 0);
    opacity: 0;
  }
  20% {
    transform: translate(-50%, -20px);
    opacity: 1;
  }
  80% {
    transform: translate(-50%, -40px);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -60px);
    opacity: 0;
  }
}

/* Mobile-only race section — hidden on desktop */
.gt-mobile-race {
  display: none;
}

/* Projector Tabs - hidden on desktop */
.gt-projector-tabs {
  display: none;
}

/* Mobile-only end game button — hidden on desktop */
.gt-mobile-end-btn {
  display: none;
}

/* ===== MOBILE RESPONSIVE ===== */
@media (max-width: 1024px) {
  .gt-overlay {
    overflow: hidden;
  }

  .gt-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    height: 44px;
    padding: 0 16px;
  }

  .gt-main {
    flex-direction: column;
    overflow: hidden;
    position: absolute;
    top: 44px;
    left: 0;
    right: 0;
    bottom: 84px; /* Space for END GAME button */
    height: auto;
    margin: 0;
  }

  /* LEFT PANEL: becomes the scrollable content area on mobile */
  .gt-left-panel {
    width: 100%;
    border-right: none;
    padding: 16px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    flex: 1;
    min-height: 0;
    order: 1;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    background: transparent;
  }

  .gt-timer-box {
    margin-bottom: 8px;
    padding: 16px;
    display: grid;
    grid-template-areas:
      'label value'
      'bar  bar';
    grid-template-columns: 1fr auto;
    align-items: center;
  }

  .gt-timer-label {
    grid-area: label;
    text-align: left;
    margin-bottom: 0;
  }

  .gt-timer-value {
    grid-area: value;
    font-size: 22px;
    margin-bottom: 0;
    text-align: right;
  }

  .gt-timer-bar-container {
    grid-area: bar;
    margin-top: 14px;
  }

  /* CENTER PANEL: sits inside the scroll flow on mobile (above leaderboard) */
  .gt-center-panel {
    order: 0;
    width: 100%;
    flex: none;
    padding: 0;
    height: auto;
    min-height: 0;
    position: static;
  }

  /* Hide desktop center panel rockets on mobile (mobile-only version in left panel) */
  .gt-center-panel:not(.gt-center-slides) {
    display: none;
  }

  .gt-section-title {
    margin-bottom: 12px;
    text-align: center;
  }

  /* Projector Tabs - visible on mobile */
  .gt-projector-tabs {
    display: flex;
    margin-bottom: 24px;
    border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  }
  .gt-pt-tab {
    flex: 1;
    text-align: center;
    padding: 10px 0;
    font-size: 12px;
    color: #8c99a0;
    cursor: pointer;
    font-weight: 500;
  }
  .gt-pt-tab.active {
    color: #00ffff;
    border-bottom: 2px solid #00ffff;
    margin-bottom: -2px; /* to overlap the parent border */
  }

  .gt-hide-on-mobile {
    display: none !important;
  }

  /* Mobile-only race section */
  .gt-mobile-race {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }

  .gt-mobile-race-labels {
    display: none;
  }

  .gt-mobile-race-label {
    text-align: center;
    width: 50px;
  }

  .gt-mobile-race-name {
    font-size: 9px;
    font-weight: bold;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    margin-bottom: 2px;
  }

  .gt-mobile-race-pct {
    display: none;
  }

  /* RACE TRACK: vertical rockets for mobile */
  .gt-mobile-race-track {
    width: 100%;
    flex: 1;
    display: flex;
    justify-content: space-around;
    align-items: flex-end;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .gt-mobile-race-track .gt-rocket-lane {
    width: 75px;
    height: 100%;
  }

  .gt-mobile-race-track .rocket-svg {
    width: 65px;
  }

  .gt-mobile-race-track .gt-rocket-tail {
    height: 120px;
    width: 4px;
  }

  .gt-mobile-race-track .rocket-finished .rocket-svg {
    width: 80px;
    transform: translateY(-10px);
  }

  .gt-mobile-race-track .rocket-finished .gt-rocket-tail {
    width: 8px;
    height: 180px;
  }

  /* LEADERBOARD: full width cards, no own scroll */
  .gt-leaderboard {
    flex: none;
    overflow-y: visible;
    gap: 8px;
    margin-bottom: 16px;
  }

  .gt-lb-card {
    padding: 10px 12px;
  }

  .gt-lb-rank {
    font-size: 14px;
    width: 26px;
  }

  .gt-lb-name {
    font-size: 10px;
  }

  .gt-lb-points {
    font-size: 14px;
  }

  /* Hide original END GAME button on mobile (replaced by gt-mobile-end-btn) */
  .gt-btn-end {
    display: none;
  }

  /* Mobile END GAME button: fixed at bottom, outside scrollable area */
  .gt-mobile-end-btn {
    display: block;
    position: fixed;
    bottom: 10px;
    left: 12px;
    right: 12px;
    z-index: 100001;
    width: calc(100vw - 24px);
    margin: 0;
    background: #ff00ff;
    color: #fff;
    border: none;
    padding: 14px 0;
    border-radius: 8px;
    font-size: 11px;
    font-weight: bold;
    letter-spacing: 1px;
    cursor: pointer;
    box-shadow: 0 0 15px rgba(255, 0, 255, 0.4);
    box-sizing: border-box;
    -webkit-appearance: none;
    appearance: none;
  }

  /* RECENT ACTIVITY */
  .gt-recent-activity {
    margin-bottom: 16px;
  }

  /* RIGHT PANEL: hide on mobile */
  .gt-right-panel {
    display: none;
  }

  /* DASHBOARD: cards in single column */
  .gt-dashboard-grid {
    grid-template-columns: 1fr;
    padding: 10px;
    gap: 12px;
  }

  .gt-dashboard-card {
    height: 155px;
    min-height: 155px;
    position: relative;
    padding-bottom: 56px;
    overflow: hidden;
  }
  .gt-dashboard-card.gt-mobile-expanded {
    height: auto;
  }

  .gt-dashboard-card-body {
    gap: 4px !important;
  }

  .gt-dashboard-card-body > * {
    flex-shrink: 0;
  }

  .gt-cpa-question-text {
    min-height: auto;
    margin-bottom: 0;
    font-size: 12px !important;
  }

  .gt-dashboard-card-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 2;
    box-sizing: border-box;
  }

  /* Score popup */
  .gt-score-popup {
    font-size: 14px;
  }

  /* Dashboard mobile specific tabs */
  .gt-dashboard-tabs {
    display: flex;
    justify-content: space-between;
  }
  .gt-dashboard-tabs .gt-pt-tab {
    font-size: 10px;
    padding: 8px 0;
  }

  /* Structural overrides for mobile dashboard */
  .gt-mobile-dashboard {
    position: absolute !important;
    top: 44px !important;
    bottom: 84px !important;
    left: 0 !important;
    right: 0 !important;
    height: auto !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-y: contain;
    background: transparent !important;
  }
  .gt-mobile-dashboard .gt-left-panel {
    flex: none;
    overflow-y: visible;
    padding-bottom: 20px;
    min-height: auto;
  }
  .gt-mobile-dashboard .gt-center-panel {
    order: 2;
    flex: none !important;
    padding-bottom: 20px;
  }
  .gt-center-panel > div {
    height: auto !important;
    overflow-y: visible !important;
  }

  .gt-show-on-mobile-flex {
    display: flex !important;
  }

  .gt-right-panel.gt-show-on-mobile-flex {
    order: 3;
    width: 100%;
    padding: 16px;
    padding-bottom: 80px;
    border: none;
    flex: none;
    min-height: 0;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    background: transparent;
  }
  .gt-log-list {
    overflow-y: visible;
  }
  .gt-log-item {
    backdrop-filter: none !important;
    -webkit-backdrop-filter: none !important;
    background: rgba(18, 30, 36, 0.95);
  }

  .gt-mobile-collapse {
    display: none !important;
  }
}

/* CPA White Card Overrides */
.gt-cpa-card-white {
  background: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
}
.gt-cpa-card-header-white {
  background: #ffffff !important;
  border-bottom: 1px solid #f1f5f9 !important;
  padding: 16px 20px !important;
}
.gt-cpa-card-footer-white {
  background: #ffffff !important;
  border-top: 1px solid #f1f5f9 !important;
}
.gt-cpa-card-title {
  color: #334155;
}
.gt-normal-card-title {
  color: #00ffff;
}
.gt-cpa-header-stats {
  display: flex;
  gap: 12px;
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
}
.gt-stat-attempted {
  color: #64748b;
  font-size: 10px;
}
.gt-stat-stuck {
  color: #eab308;
  font-size: 10px;
}
.gt-stat-wrong {
  color: #f43f5e;
  font-size: 10px;
}

/* CPA Table */
.gt-cpa-table-container {
  margin-top: 10px;
}
.gt-cpa-table-container::-webkit-scrollbar-thumb {
  background: rgba(100, 116, 139, 0.3) !important;
  border-radius: 2px;
}
.gt-cpa-table-container::-webkit-scrollbar-thumb:hover {
  background: rgba(100, 116, 139, 0.5) !important;
}
.gt-cpa-table {
  width: 100%;
}
.gt-cpa-table-header {
  border-bottom: none !important;
  margin-bottom: 4px !important;
  padding-bottom: 0 !important;
  display: flex;
  align-items: center;
  width: 100%;
  min-width: max-content;
}
.gt-cpa-table-header > div {
  color: #64748b !important;
  font-weight: 700 !important;
  font-size: 10px !important;
  letter-spacing: 0.5px !important;
}
.gt-cpa-rows {
  gap: 12px !important;
  display: flex;
  flex-direction: column;
}
.gt-cpa-row {
  background: #f8fafc !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 12px 0 !important;
  display: flex;
  align-items: center;
  width: 100%;
  min-width: max-content;
}
.gt-cpa-col-level {
  display: flex;
  align-items: center;
  gap: 10px;
}
.gt-cpa-level-badge {
  background: #64748b;
  color: #ffffff;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  font-weight: bold;
}
.gt-cpa-level-name {
  color: #475569;
  font-size: 10px;
  font-weight: 500;
}
.gt-cpa-col-stat {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
}
.gt-cpa-view-btn {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  color: #64748b;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
  letter-spacing: 0.5px;
  transition: all 0.2s;
}
.gt-cpa-view-btn:hover {
  background: #f1f5f9;
  color: #334155;
}
</style>

<style>
.el-notification {
  z-index: 1000000005 !important;
}
.el-message {
  z-index: 1000000005 !important;
}
</style>
